import { createBrowserRouter } from "react-router-dom";
import { PageNotFound } from "../../_base/component/_layout/_404";
import { Layout1 } from "../../_base/component/_layout/_layout1";
import { LayoutAuth } from "../../_base/component/_layout/_layoutAuth";
import LayoutLogin from "../../_base/component/_login/_LayoutLogin";
import { SelectListItem } from "../../model/SelectListItem";
import AppView from "../../views/Auth/AppView";
import AuthListRoleView from "../../views/Auth/AuthListRoleView";
import GroupsRoleView from "../../views/Auth/GroupsRoleView";
import LoggingView from "../../views/Auth/LoggingView";
import TopicErrorView from "../../views/Auth/TopicErrorView";
import UserListView from "../../views/Auth/UserListView";
import Commodities from "../../views/Category/Commodities/Commodities";
import TagConfig from "../../views/Category/TagConfig/TagConfig";
import GeneralData from "../../views/Category/GeneralData/GeneralData";
import Payment from "../../views/Category/Payment/Payment";
import ServiceRepairTestingTechniqueList from "../../views/ServiceRepair/ServiceRepairTestingTechniqueList";
import Transport from "../../views/Category/Transport/Transport";
import ListDetailsPrice from "../../views/ConfigSystem/PriceList/ListDetailsPrice";
import ListPrice from "../../views/ConfigSystem/PriceList/ListPrice";
import CreatePromotionPolicy from "../../views/ConfigSystem/PromotionPolicy/CreatePromotionPolicy/CreatePromotionPolicy";
import PromotionPolicy from "../../views/ConfigSystem/PromotionPolicy/PromotionPolicy";
import ViewDetailPromotion from "../../views/ConfigSystem/PromotionPolicy/ViewPromotion/ViewPromotion";
import DeliveryAssignment from "../../views/DeliveryConfig/DeliveryAssignment";
import DepartmentView from "../../views/Organization/DepartmentView";
import EmployeeView from "../../views/Organization/EmployeeView";
import RoleView from "../../views/Organization/RoleView";
import CreateRequestTransfer from "../../views/RequestTransfer/CreateRequestTransfer";
import EditRequestTransfer from "../../views/RequestTransfer/EditRequestTransfer";
import RequestTransfer from "../../views/RequestTransfer/WareHouseTransfer/RequestTransfer";
import DmCustomer from "../../views/Sell/Customer/TblDMCustomer";
import { PaymentReceipt } from "../../views/Sell/PaymentReceipt/PaymentReceipt";
import RetailOrder from "../../views/Sell/RetailOrder";
import PaymentForm from "../../views/Sell/ScreenPayment";
import InventoryCycleCount from "../../views/Warehouse/WarehouseManagement/InventoryCycleCount/InventoryCycleCount";
import WarehouseManagement from "../../views/Warehouse/WarehouseManagement/WarehouseManagement";
import RequestInventoryTransaction from "../../views/Warehouse/WarehouseOutWard/pages/RequestOutWardTransaction";
import WarehouseOutWard from "../../views/Warehouse/WarehouseOutWard/WarehouseOutWard";
import ReceptionList from "../../views/Warranty/ReceiveWarranty/ReceptionList";
import ReceiveWarrantyDetailView from "../../views/Warranty/ReceiveWarranty/DetailDataView";
import SupplierWarrantyExport from "../../views/Warranty/SupplierWarrantyExport/SupplierWarrantyExport";
// import SaleReviseOrder from "../../views/Sell/SaleReviseOrder/SaleReviseOrder";
import DetailRequestTransfer from "../../views/RequestTransfer/DetailRequestTransfer";
import InventoryBarcode from "../../views/Warehouse/InventoryBarcode/InventoryBarcode";

import CustomerList from "../../views/CustomerManagement/CustomerList/CustomerList";
import { ExchangeRate } from "../../views/Sell/exchangeRate/exchangeRate";
import TestingTechnique from "../../views/TestingTechnique";
import WarehouseTransaction from "../../views/Warehouse/WarehouseTransaction/WarehouseTransaction";
import ProcessingAssignment from "../../views/Warranty/RequestProcessing/ProcessingAssignment";
import WarrantyCompany from "../../views/Warranty/WarrantyCompany/WarrantyCompany";
// import ReducedApproval from "../../views/ReducedApproval/ReducedApproval";
import GroupUserView from "../../views/Auth/GroupUserView";
import { HistoryAndApprove } from "../../views/Auth/HistoryAndApprove/HistoryAndApprove";
import ListOnlineView from "../../views/Auth/ListOnlineView";
import PermissionsPage from "../../views/Auth/PermissionsPage";
import UserPageView from "../../views/Auth/UserPageView";
import CreateMfgBom from "../../views/ConfigSystem/MfgBom/CreateMfgBom";
import DetailMfgBom from "../../views/ConfigSystem/MfgBom/DetailMfgBom";
import EditMfgBom from "../../views/ConfigSystem/MfgBom/EditMfgBom";
import MfgBomView from "../../views/ConfigSystem/MfgBom/MfgBom";
import ListDetailsPriceDetai from "../../views/ConfigSystem/PriceList/ListDetailsPriceDetai";
import ListDetailsPriceEditOld from "../../views/ConfigSystem/PriceList/ListDetailsPriceEditOld";
import EditPromotionPolicyV2 from "../../views/ConfigSystem/PromotionPolicy/EditPromotionPolicyV2/EditPromotionPolicyV2";
import DebtGroupListCus from "../../views/DebtGroup/DebtGroupListCus";
import DeliveryPay from "../../views/DeliveryConfig/DeliveryPay/DeliveryPay";
import DepartmentsList from "../../views/Departments/DepartmentsList";
import Invoice from "../../views/Invoice/DMInvoice";
import MenuView from "../../views/Menu/MenuView";
import MenuGroupListView from "../../views/MenuGroup/MenuGroupListView";
// import { ApproveProposalView } from "../../views/Proposal/ApproveProposal/ApproveProposalView";
// import { CreateProposalView } from "../../views/Proposal/CreateProposal/CreateProposalView";
// import { DetailProposalView } from "../../views/Proposal/DetailProposal/DetailProposalView";
// import { EditProposalView } from "../../views/Proposal/EditProposal/EditProposalView";
// import { ProposalView } from "../../views/Proposal/ProposalView";
import Delivery2 from "../../views/DeliveryConfig/Delivery/index2";
import DeliveryDispatchDV from "../../views/DeliveryConfig/DeliveryDispatch/indexDV";
import ReducedApproval from "../../views/ReducedApproval/ReducedApproval";
import { AddOrUpdateFileReportView } from "../../views/Report/AddOrUpdateFileReportView";
import { GridExample } from "../../views/Report/ExampleView";
import { ReportInventorySerialOnhandView } from "../../views/Report/ReportInventorySerialOnhandView";
import ReportPaymentReceiptViewV2 from "../../views/Report/ReportPaymentReceiptViewV2";
import { ReportSalesListView } from "../../views/Report/ReportSalesListView";
import AddAdjustmentSlip from "../../views/Sell/AddAdjustmentSlip/AddAdjustmentSlip";
import CreditAdvice from "../../views/Sell/Bill/CreditAdvice/CreditAdvice";
import DebtNote from "../../views/Sell/Bill/DebtNote/DebtNote";
import DebtNoteBranchs from "../../views/Sell/Bill/DebtNoteBranchs/DebtNoteBranchs";
import DetailListReceipts from "../../views/Sell/Bill/ListReceipts/DetailListReceipts";
import ListPaymentSlip from "../../views/Sell/Bill/ListReceipts/ListPaymentSlip";
import ListReceipts from "../../views/Sell/Bill/ListReceipts/ListReceipts";
import { OrderConfirmation } from "../../views/Sell/Bill/OrderConfirmation/orderConfirmation";
import PaymentSlip from "../../views/Sell/Bill/PaymentSlip/PaymentSlip";
import PaymentSlipBranchs from "../../views/Sell/Bill/PaymentSlipBranchs/PaymentSlipBranchs";
import LabelPrinting from "../../views/Sell/LabelPrinting";
import InternalReceipt from "../../views/Sell/PaymentReceipt/InternalReceipt/InternalReceipt";
import ReturnOrderTechnical from "../../views/Sell/RetailOrder/ReturnOrderTechnical";
import ReturnOrderV2 from "../../views/Sell/RetailOrder/ReturnOrderV2";
import WholeSale from "../../views/Sell/RetailOrder/WholeSale";
import ReturnOrder from "../../views/Sell/ReturnOrder/ReturnOrder";
import GeneralSalesStatement from "../../views/Sell/SalesStatisticsList/GeneralSalesStatement/GeneralSalesStatement";
import ProductPLReport from "../../views/Sell/SalesStatisticsList/ProductPLReport/ProductPLReport";
import ReportBrach from "../../views/Sell/SalesStatisticsList/ReportBrach/ReportBrach";
import ReportByPeriod from "../../views/Sell/SalesStatisticsList/ReportByPeriod/ReportByPeriod";
import ReportCustomer from "../../views/Sell/SalesStatisticsList/ReportCustomer/ReportCustomer";
import ReportDepartment from "../../views/Sell/SalesStatisticsList/ReportDepartment/ReportDepartment";
import ReportPhone from "../../views/Sell/SalesStatisticsList/ReportPhone/ReportPhone";
import ReportPrice from "../../views/Sell/SalesStatisticsList/ReportPrice/ReportPrice";
import ReportProductDefects from "../../views/Sell/SalesStatisticsList/ReportProductDefects/ReportProductDefects";
import ReportProfitLossByInvoice from "../../views/Sell/SalesStatisticsList/ReportProfitLossByInvoice/ReportProfitLossByInvoice ";
import DetailSellOrderInformation from "../../views/Sell/SellOrderIinformation/DetailSellOrderInformation";
import SellOrderIinformation from "../../views/Sell/SellOrderIinformation/SellOrderIinformation";
import ModalAssignTestingTechnique from "../../views/TestingTechnique/ModalAssignTestingTechnique";
import ModalDetailTestingTechnique from "../../views/TestingTechnique/ModalDetailTestingTechnique";
import ModalUpdateTestingTechnique from "../../views/TestingTechnique/ModalUpdateTestingTechnique";
import BarcodeHistory from "../../views/Warehouse/BarcodeHistory/BarcodeHistory";
import BarcodeHistoryV2 from "../../views/Warehouse/BarcodeHistory/BarcodeHistoryV2";
import { BarcodeStatus } from "../../views/Warehouse/BarcodeStatus/BarcodeStatus";
import CategoryCombination from "../../views/Warehouse/CategoryCombination/CategoryCombination";
import ExportAdjustment from "../../views/Warehouse/ExportAdjustment/ExportAdjustment";
import ImportPurchases from "../../views/Warehouse/ImportPurchases/ImportPurchases";
import ImportPurchasesDetail from "../../views/Warehouse/ImportPurchases/importPurchasesDetail";
import ImportPurchasesView from "../../views/Warehouse/ImportPurchases/ImportPurchasesView";
import InOutWarehouseOutWard from "../../views/Warehouse/InOutWarehouseManagement/WarehouseOutWard";
import InventoryReportList from "../../views/Warehouse/InventoryReport/InventoryReportList";
import InventoryReportHbList from "../../views/Warehouse/InventoryReport/InventoryReportHbList";
import InventoryReportByBarcode from "../../views/Warehouse/InventoryReportByBarcode/InventoryReportByBarcode";
import InventoryReportLocation from "../../views/Warehouse/InventoryReportLocation/InventoryReportLocation";
import InventoryTransactionsReport from "../../views/Warehouse/InventoryTransactionsReport/InventoryTransactionsReport";
import ListSerial from "../../views/Warehouse/ListSerial/ListSerial";
import MfgWip from "../../views/Warehouse/MfgWip/MfgWip";
import ProductSeparation from "../../views/Warehouse/ProductSeparation/ProductSeparation";
import SparePartReport from "../../views/Warehouse/SparePartReport/SparePartReport";
import CreateWarehousePurchaseInWard from "../../views/Warehouse/WarehouseInWard/CreateWarehousePurchaseInWard";
import InwardRequest from "../../views/Warehouse/WarehouseInwardNew/pages/RequestInWardTransaction";
import WarehouseInWard from "../../views/Warehouse/WarehouseInwardNew/WarehouseInWard";
import WarehouseInWardPlus from "../../views/Warehouse/WarehouseInWardPlus/WarehouseInWardPlus";
import WarehouseLocationList from "../../views/Warehouse/WarehouseLocationList/WarehouseLocationList";
import DefectiveGoodsListV2 from "../../views/Warranty/DefectiveGoodsList/DefectiveGoodListV2";
import DefectiveGoodsList from "../../views/Warranty/DefectiveGoodsList/DefectiveGoodsList";
import InformationWarranty from "../../views/Warranty/InformationWarranty/InformationWarranty";
import PerformHomeWarranty from "../../views/Warranty/PerformHomeWarranty/PerformHomeWarranty";
import ProductWarrantyHistory from "../../views/Warranty/ProductWarrantyHistory/ProductWarrantyHistory";
import PurchaseHistory from "../../views/Warranty/PurchaseHistory/PurchaseHistory";
import WarrantyReceiveItem from "../../views/Warranty/ReceiptWarranty/WarrantyReceiveItem";
import ReceiveTicketList from "../../views/Warranty/ReceiveTicket/ReceiveTicketList";
import ReceiveTicketDetailView from "../../views/Warranty/ReceiveTicket/DetailDataView";
import ServiceRepairList from "../../views/ServiceRepair/ServiceRepairList";
import ServiceRepairDetailView from "../../views/ServiceRepair/ServiceRepairDetailView";
import ServiceRepairDefectiveGoodsList from "../../views/ServiceRepair/ServiceRepairDefectiveGoodsList";
import ReturnCustomers from "../../views/Warranty/ReturnCustomers/ReturnCustomers";
import WarrantyConversionData from "../../views/Warranty/WarrantyConversionData/WarrantyConversionData";
import WarrantyInformation from "../../views/Warranty/WarrantyInformation/WarrantyInformation";
import CreateExportBorrwedGood from "../../views/Warranty/WarrantyLoanRequestForm/DMExportBorrowedGoods/CreateExportBorrwedGood";
import DetailExportBorredGood from "../../views/Warranty/WarrantyLoanRequestForm/DMExportBorrowedGoods/DetailExportBorredGood";
import DMBorrwedGoods from "../../views/Warranty/WarrantyLoanRequestForm/DMExportBorrowedGoods/DMExportBorrwedGoods";
import EditExportBorred from "../../views/Warranty/WarrantyLoanRequestForm/DMExportBorrowedGoods/EditExportBorred";
import WarrantyRenewalList from "../../views/Warranty/WarrantyRenewal/WarrantyRenewalList";
import WarrantyCustomerGroupList from "../../views/Warranty/WarrantyCustomerGroup/WarrantyCustomerGroupList";

import { LayoutAnonymus } from "../../_base/component/_layout/_layoutAnonymus";
import CheckDataClickHouseLogView from "../../views/Auth/CheckDataClickHouseLogView";
import CheckDataLogView from "../../views/Auth/CheckDataView";
import DecentralizeRedution from "../../views/Auth/DecentralizeReduction/DecentralizeRedution";
import ReturnTechnicalExchange from "../../views/Auth/ReturnTechnicalExchange/ReturnTechnicalExchange";
import AccountInformation from "../../views/Category/AccountInformation/AccountInformation";
import AddressConversion from "../../views/Category/AddressConversion/AddressConversion";
import DMInventory from "../../views/Category/GeneralData/DMInventory/DMInventory";
import ReportCategory from "../../views/Category/ReportCategory/ReportCategory";
import TemProduct from "../../views/Category/TemProduct/TemProduct";
import CreateView from "../../views/Category/VoucherData/CreateView";
import DetailView from "../../views/Category/VoucherData/DetailView";
import EditView from "../../views/Category/VoucherData/EditView";
import ListVoucher from "../../views/Category/VoucherData/ListVoucher";
import CompareDataAsiaPOS from "../../views/CompareData/CompareDataAsiaPOS/CompareDataAsiaPOS";
import CompareInventory from "../../views/CompareData/CompareInventory/CompareInventory";
import CompareItemPOSAndWeb from "../../views/CompareData/CompareItemPOSAndWeb/CompareItemPOSAndWeb";
import TabDuplicateReport from "../../views/ConfigSystem/DuplicateReport/TabDuplicateReport";
import ItemFluctuation from "../../views/ConfigSystem/ItemFluctuation/ItemFluctuation";
import ZNSConfiguration from "../../views/ConfigSystem/ZNSConfiguration";
import PriceListUpdateHistory from "../../views/ConfigSystem/PriceListUpdateHistory/PriceListUpdateHistory";
import PriceListUpdateHistoryNoImportPrice from "../../views/ConfigSystem/PriceListUpdateHistoryNoImportPrice/PriceListUpdateHistoryNoImportPrice";
import ListPromotionByItem from "../../views/ConfigSystem/PromotionByItem/ListPromotionByItem";
import DetailPromotion from "../../views/ConfigSystem/PromotionPolicy/DetailPromotion";
import ProfitRevenue from "../../views/ConfigSystem/PromotionPolicy/ProfitRevenue";
import CreatePromotionPolicyMultiple from "../../views/ConfigSystem/PromotionPolicyV2/CreatePromotionPolicy/CreatePromotionPolicy";
import EditPromotionPolicyMultiple from "../../views/ConfigSystem/PromotionPolicyV2/EditPromotionPolicy/EditPromotionPolicy";
import PromotionPolicyMultiple from "../../views/ConfigSystem/PromotionPolicyV2/PromotionPolicy";
import DetailPromotionPolicyMultiple from "../../views/ConfigSystem/PromotionPolicyV2/ViewPromotion/DetailPromotionPolicy";
import RockBottomPriceList from "../../views/ConfigSystem/RockBottomPriceList/RockBottomPriceList";
import SchedulePriceListUpload from "../../views/ConfigSystem/SchedulePriceListUpload/SchedulePriceListUpload";
import SetUpDiscounts from "../../views/ConfigSystem/SetUpDiscounts/SetUpDiscounts";
import CheckDataView from "../../views/ConfigSystem/SyncCheckingExist/CheckDataView";
import TabSyncCheckingExit from "../../views/ConfigSystem/SyncCheckingExist/TabSyncCheckingExit";
import Address from "../../views/CustomerManagement/Address/Address";
import DeliveryInOneDay from "../../views/DeliveryConfig/DeliveryInOneDay/DeliveryInOneDay";
import DeliveryMoney from "../../views/DeliveryConfig/DeliveryMoneyReport/DeliveryMoney";
import DeliveryMoneyReport from "../../views/DeliveryConfig/DeliveryMoneyReport/DeliveryMoneyReport";
import Ahamove from "../../views/DeliveryConfig/DeliveryPartner/Ahamove";
import GHTKAndAhamoveDelivery from "../../views/DeliveryConfig/DeliveryPartner/GHTK&AhamoveDelivery";
import DeliveryPayKT from "../../views/DeliveryConfig/DeliveryPay/DeliveryPayKT";
import DeliveryPerformanceReport from "../../views/DeliveryConfig/DeliveryPerformanceReport/DeliveryPerformanceReport";
import DeliveryProjectReport from "../../views/DeliveryConfig/DeliveryProjectReport/DeliveryProjectReport";
import ReportOnOrders from "../../views/DeliveryConfig/ReportOnOrders/ReportOnOrders";
import HomeViewProd from "../../views/home/HomeViewProd";
import { MenuAlignmentView } from "../../views/MenuGroup/MenuAlignmentView";
import ReasonForReturn from "../../views/ReasonForReturn/ReasonForReturn";
import ReportSerialChild from "../../views/Report/ReportSerialChild";
import ReportVCheckTranferRequestQueryView from "../../views/Report/ReportVCheckTranferRequestQueryView";
import RequestTransferInternal from "../../views/RequestTransfer/WareHouseTransfer/RequestWarehouseTransfer/RequestTransferInternal";
import { AdjustmentSlip } from "../../views/Sell/AdjustmentSlip/AdjustmentSlip";
import PrintProductLabel from "../../views/Sell/PrintProductLabel/PrintProductLabel";
import { AdjustmentSlipOrder } from "../../views/Sell/AdjustmentSlip/AdjustmentSlipOrder";
import { AdjustmentSlipTransaction } from "../../views/Sell/AdjustmentSlip/AdjustmentSlipTransaction";
import ApproveApplicationList from "../../views/Sell/ApproveApplicationList/ApproveApplicationList";
import BankTransactions from "../../views/Sell/BankingTransactions/BankingTransactions";
import NewspaperListAvailable from "../../views/Sell/Bill/ListReceipts/NewspaperListAvailable";
import CompareSaleOrderWeb from "../../views/Sell/CompareSaleOrderWeb";
import EditPriceProduct from "../../views/Sell/EditPriceProduct";
import PromotionDebtList from "../../views/Sell/PromotionDebtList";
import PurchaseRegistrationList from "../../views/Sell/PurchaseRegistrationList/PurchaseRegistrationList";
import ReportOrderListListReturn from "../../views/Sell/ReportOrderListListReturn";
import ReportPriceList from "../../views/Sell/ReportPriceList/ReportPriceList";
import ReturnOrderAll from "../../views/Sell/RetailOrder/ReturnOrderAll";
import SaleOrderListNoAddressCus from "../../views/Sell/SaleOrderListNoAddressCus";
import SaleOrderListWebsite from "../../views/Sell/SaleOrderListWebsite";
import SalesOrderListApprovedReturn from "../../views/Sell/SalesOrderListApprovedReturn";
import SalesOrderListCompleted from "../../views/Sell/SalesOrderListCompleted";
import SalesOrderListInstallment from "../../views/Sell/SalesOrderListInstallment";
import SalesOrderListListReturn from "../../views/Sell/SalesOrderListListReturn";
import SalesOrderViewOpproval from "../../views/Sell/SalesOrderListOpproval";
import SalesOrderViewV2 from "../../views/Sell/SalesOrderListV2";
import BaoCaoGiamGia from "../../views/Sell/SalesStatisticsList/BaoCaoGiamGia/BaoCaoGiamGia";
import InventoryAge from "../../views/Sell/SalesStatisticsList/InventoryAge/InventoryAge";
// import InventoryAgeBranch from "../../views/Sell/SalesStatisticsList/InventoryAgeBranch/InventoryAgeBranch";
// import InventoryAgeItem from "../../views/Sell/SalesStatisticsList/InventoryAgeItem/InventoryAgeItem";
// import InventoryAgeItemGroup from "../../views/Sell/SalesStatisticsList/InventoryAgeItemGroup/InventoryAgeItemGroup";
import CustomerOrderReport from "../../views/Sell/SalesStatisticsList/CustomerOrderReport/CustomerOrderReport";
import ReportSaleOrder from "../../views/Sell/SalesStatisticsList/ReportSaleOrder/ReportSaleOrder";
import ReportTransaction from "../../views/Sell/SalesStatisticsList/ReportVallTransaction/ReportVallTransaction";
import SalesBarcodeV2 from "../../views/Sell/SalesStatisticsList/SalesBarcode/SalesBarcodeV2";
// import SalesInventoryValue from "../../views/Sell/SalesStatisticsList/SalesInventoryValue/SalesInventoryValue";
import VoucherUsageHistory from "../../views/Category/VoucherUsageHistory/VoucherUsageHistory";
import CompareVT from "../../views/CompareData/CompareDataAsiaPOS/CompareVT";
import SalesReportByProduct from "../../views/Sell/SalesStatisticsList/SalesReportByProduct/SalesReportByProduct";
import SalesRevenueReport from "../../views/Sell/SalesStatisticsList/SalesRevenueReport/SalesRevenueReport";
import ListOrderTMDTV2 from "../../views/Sell/TMDT/ListOrderTMDTV2";
import ListOrderTMDTReadOnly from "../../views/Sell/TMDT/ListOrderTMDTReadOnly";
import OrderDetailTMĐT from "../../views/Sell/TMDT/OrderDetailTMĐT";
import ListOrderReturnTMDT from "../../views/Sell/TMDTReturn/ListOrderReturnTMDT";
import ListOrderCancelTMDT from "../../views/Sell/TMDTCancel/ListOrderCancelTMDT";
import OrderDetailReturnTMDT from "../../views/Sell/TMDTReturn/OrderDetailReturnTMDT";
import CreateTestingTechnique from "../../views/TestingTechnique/CreateTestingTechnique";
import PayrollReport from "../../views/TestingTechnique/PayrollReport";
import ReportTotalEmployee from "../../views/TestingTechnique/ReportTotalEmployee";
import ChangeInformation from "../../views/Warehouse/ChangeInformation/ChangeInformation";
import InventoryDocuments from "../../views/Warehouse/InventoryDocuments/InventoryDocuments";
import InventorySerialOnhandByBranch from "../../views/Warehouse/InventorySerialOnhandByBranch/ReportInventorySerialOnhandByBranch";
import MachineInstallationInventoryReport from "../../views/Warehouse/MfgWip/MachineInstallationInventoryReport/MachineInstallationInventoryReport";
import MfgWipReport from "../../views/Warehouse/MfgWip/MfgWipReport/MfgWipReport";
import ReportGeneralInventory from "../../views/Warehouse/ReportGeneralInventory/ReportGeneralInventory";
import ReportInOutBalance from "../../views/Warehouse/ReportInOutBalanceV2/ReportInOutBalanceV2";
import ReportInventoryBySerial from "../../views/Warehouse/ReportInventoryBySerial/ReportInventoryBySerial";
import ReportRequestTransfer from "../../views/Warehouse/ReportRequestTransfer/ReportRequestTransfer";
import SerialStocktake from "../../views/Warehouse/SerialStocktake/SerialStocktake";
import {
  SerialStocktakeDifferenceReport,
  SerialStocktakeSummaryReport,
} from "../../views/Warehouse/SerialStocktakeReports/SerialStocktakeReports";
import StorageReport from "../../views/Warehouse/StorageReport/StorageReport";
import StorageReportOrder from "../../views/Warehouse/StorageReportOrder/StorageReportOrder";
import { SupplierSlipExport } from "../../views/Warehouse/SupplierSlipExport/SupplierSlipExport";
import { SupplierSlipImport } from "../../views/Warehouse/SupplierSlipImport/SupplierSlipImport";
import InwardActionDispatcher from "../../views/Warehouse/ReturnInward/routing/InwardActionDispatcher";
import OutwardActionDispatcher from "../../views/Warehouse/SaleOutward/routing/OutwardActionDispatcher";
import ExportOrReExport from "../../views/Warranty/ExportOrReExport/ExportOrReExport";
import HistorySMSBH from "../../views/Warranty/HistorySMSBH/HistorySMSBH";
import InventoryRecord from "../../views/Warranty/InventoryRecord/InventoryRecord";
import { QrCodeWarranty } from "../../views/Warranty/QrCodeWarranty/QrCodeWarranty";
import CustMeeting from "../../views/Warranty/ReceiveWarranty/CustMeeting";
import RequestFormReport from "../../views/Warranty/ReceiveWarranty/RequestFormReport";
import ReportDefectiveGoodsRate from "../../views/Warranty/ReportDefectiveGoodsRate/ReportDefectiveGoodsRate";
import ReportDeliveryPerformance from "../../views/Warranty/ReportDeliveryPerformance/ReportDeliveryPerformance";
import ReportForMonth from "../../views/Warranty/ReportForMonth/ReportForMonth";
import SendWarrantyClaim from "../../views/Warranty/SendWarrantyClaim/SendWarrantyClaim";
import InventoryImportReturn from "../../views/Warranty/SupplierWarrantyExport/InventoryImportReturn/InventoryImportReturn";
import ReportExportSupplier from "../../views/Warranty/SupplierWarrantyExport/ReportExportSupplier/ReportExportSupplier";
import TrackingReportKTBH from "../../views/Warranty/TrackingReportKTBH/TrackingReportKTBH";
import WarrantyClaimInformation from "../../views/Warranty/WarrantyClaimInformation/WarrantyClaimInformation";
// import SalesOrderListDetail from "../../views/Sell/SalesOrderListDetail";
import DeleteCache from "../../views/Auth/DeleteCache";
import TabListDeliveryConfig from "../../views/Category/DeliveryConfig/TabListDeliveryConfig";
import ReasonRequestTransfer from "../../views/Category/ReasonRequestTransfer/ReasonRequestTransfer";
import SerialStatus from "../../views/Category/SerialStatus/SerialStatus";
import TechnicalConfiguration from "../../views/Category/TechnicalConfiguration/TechnicalConfiguration";
import TestLevelCategories from "../../views/Category/TestLevelCategories/TestLevelCategories";
import CompareDefectivePOSAndAsia from "../../views/CompareData/CompareDefectivePOSAndAsia/CompareDefectivePOSAndAsia";
import ComparePromotionPOSAndWEB from "../../views/ConfigSystem/ComparePromotionPOSAndWEB/ComparePromotionPOSAndWEB";
import CountExportImportSerial from "../../views/ConfigSystem/CountExportImportSerial/CountExportImportSerial";
import GetCountBrandSerial from "../../views/ConfigSystem/GetCountBrandSerial/GetCountBrandSerial";
import GetProductBySerial from "../../views/ConfigSystem/GetProductBySerial/GetProductBySerial";
import GetTHEKPHG from "../../views/ConfigSystem/GetTHEKPHG/GetTHEKPHG";
import GetWarningFIFO from "../../views/ConfigSystem/GetWarningFIFO/GetWarningFIFO";
import GetWeightSerial from "../../views/ConfigSystem/GetWeightSerial/GetWeightSerial";
import ManualPromotionProgramReport from "../../views/ConfigSystem/ManualPromotionProgramReport/ManualPromotionProgramReport";
import InventoryBySerial from "../../views/ConfigSystem/PromotionPolicy/InventoryBySerial/InventoryBySerial";
import PromotionReport from "../../views/ConfigSystem/PromotionReport/PromotionReport";
import SalesByBranch from "../../views/ConfigSystem/SalesByBranch/SalesByBranch";
import SalesByStaff from "../../views/ConfigSystem/SalesByStaff/SalesByStaff";
import SumListSerialV2 from "../../views/ConfigSystem/SumListSerial/SumListSerialV2";
import SumListSerialQKV2 from "../../views/ConfigSystem/SumListSerialQK/SumListSerialQKV2";
import ListDebtVendor from "../../views/DebtVendor/ListDebtVendorV2";
import DeliveryNotSync from "../../views/DeliveryConfig/DeliveryNotSync/DeliveryNotSync";
import ListTabCOD from "../../views/DeliveryConfig/DeliveryPartner/ListTabCOD";
import ListTabGHTK from "../../views/DeliveryConfig/DeliveryPartner/ListTabGHTK";
import DeliveryPayrollKttc from "../../views/DeliveryConfig/DeliveryPayrollKttc/DeliveryPayrollKttc";
import ExportExcel from "../../views/ExportData/ExportExcel/ExportExcel";
import SSOGetAccessKey from "../../views/KeyAccess/SSOGetAccessKey";
import RequestManagerTransfer from "../../views/RequestManagerTransfer/RequestManagerTransfer";
import { HandoverSlipCreate } from "../../views/Sell/HandoverSlip/HandoverSlipCreate";
import { HandoverSlipDetail } from "../../views/Sell/HandoverSlip/HandoverSlipDetail";
import HandoverSlipList from "../../views/Sell/HandoverSlip/HandoverSlipList";
import InventoryAgeItem from "../../views/Sell/SalesStatisticsList/InventoryAgeItem/InventoryAgeItem";
import InventoryAgeItemGroup from "../../views/Sell/SalesStatisticsList/InventoryAgeItemGroup/InventoryAgeItemGroup";
import InventoryAgeBranch from "../../views/Sell/SalesStatisticsList/nventoryAgeBranch/InventoryAgeBranch";
import PurchaseOrderReportExcludingPriceInformation from "../../views/Sell/SalesStatisticsList/PurchaseOrderReportExcludingPriceInformation/PurchaseOrderReportExcludingPriceInformation";
import ReportSaleOrderMobileApp from "../../views/Sell/SalesStatisticsList/ReportSaleOrderMobileApp/ReportSaleOrderMobileApp";
import ReportUseVoucher from "../../views/Sell/SalesStatisticsList/ReportUseVoucher/ReportUseVoucher";
import SalesInventoryValue from "../../views/Sell/SalesStatisticsList/SalesInventoryValue/SalesInventoryValue";
import SalesReportByCatSegment5e from "../../views/Sell/SalesStatisticsList/SalesReportByCatSegment5e/SalesReportByCatSegment5e";
import SalesReportByInvoiceWithBatchCodes from "../../views/Sell/SalesStatisticsList/SalesReportByInvoiceWithBatchCodes/SalesReportByInvoiceWithBatchCodes";
import SalesReportByProvinceOrWard from "../../views/Sell/SalesStatisticsList/SalesReportByProvinceOrWard/SalesReportByProvinceOrWard";
import SalesRevenueReportV2 from "../../views/Sell/SalesStatisticsList/SalesRevenueReport/SalesRevenueReportV2";
import VATManagerV2 from "../../views/Sell/WriteVAT/VATManagerV2";
import WriteVATV2 from "../../views/Sell/WriteVAT/WriteVATV2";
import ListSerialStocktaking from "../../views/Stocktaking/ListSerial/ListSerial";
import InventoryReportByBarcodeV2 from "../../views/Warehouse/InventoryReportByBarcode/InventoryReportByBarcodeV2";
import InventoryReportCompanyV2 from "../../views/Warehouse/InventoryReportCompany/InventoryReportCompanyV2";
import ReportOnComparingSerialInventoryAndQuantityInventory from "../../views/Warehouse/ReportOnComparingSerialInventoryAndQuantityInventory/ReportOnComparingSerialInventoryAndQuantityInventory";
import ReportSerialStatus from "../../views/Warehouse/ReportSerialStatus/ReportSerialStatus";
import ThongTinYeuCauNhapMua from "../../views/Warehouse/ThongTinYeuCauNhapMua/ThongTinYeuCauNhapMua";
import WeighingReport from "../../views/Warehouse/WeighingReport/WeighingReport";
import ListWarehouseData from "../../views/WarehouseData/ListWarehouseData";
import ConstructionTechnicalScoreSummaryReport from "../../views/DeliveryConfig/DeliveryPayrollKttc/ConstructionTechnicalScoreSummaryReport";
import WarrantyReceptionProcessingReport from "../../views/Warranty/WarrantyReceptionProcessingReport/WarrantyReceptionProcessingReport";
import ListOfBorrowedItems from "../../views/Warranty/ListOfBorrowedItems/ListOfBorrowedItems";
import CheckSummaryPrice from "../../views/ConfigSystem/CheckSummaryPrice/CheckSummaryPrice";
import InventoryTransferWarranty from "../../views/Warranty/InventoryTransferWarranty/InventoryTransferWarranty";
import DeliveryProjectLogisticsReport from "../../views/DeliveryConfig/DeliveryProjectLogisticsReport/DeliveryProjectLogisticsReport";
import OverduePendingOutboundReport from "../../views/Warehouse/OverduePendingOutboundReport/OverduePendingOutboundReport";
const router = createBrowserRouter([
  {
    path: "/",
    id: "root",
    element: <Layout1 />,
    errorElement: <PageNotFound />,
    action: async ({ request }) => {
      // if (auth)
      //  return protectedLoader;
    },
    children: [
      {
        path: "/",
        element: <HomeViewProd></HomeViewProd>,
      },
      {
        path: "/department",
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Danh mục dữ liệu";
            model.value = "/department";
            return model;
          },
        },
        children: [
          {
            path: "/department/department-list",
            element: <DepartmentsList></DepartmentsList>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh mục bộ phận";
                model.value = "/department/department-list";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/key-access",
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Khóa truy cập";
            model.value = "/key-access";
            return model;
          },
        },
        children: [
          {
            path: "/key-access/sso-get-access-key",
            element: <SSOGetAccessKey />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Khóa truy cập SSO";
                model.value = "/key-access/sso-get-access-key";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/category-data",
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Danh mục dữ liệu";
            model.value = "/category-data";
            return model;
          },
        },
        children: [
          {
            path: "/category-data/general-data",
            element: <GeneralData></GeneralData>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Dữ liệu chung";
                model.value = "system/category-data";
                return model;
              },
            },
          },
          {
            path: "/category-data/payment",
            element: <Payment></Payment>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thanh toán";
                model.value = "system/category-data";
                return model;
              },
            },
          },
          {
            path: "/category-data/transport",
            element: <Transport></Transport>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Giao vận";
                model.value = "system/category-data";
                return model;
              },
            },
          },
          {
            path: "/category-data/commodities",
            element: <Commodities></Commodities>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Hàng hóa";
                model.value = "system/category-data";
                return model;
              },
            },
          },
          {
            path: "/category-data/tag-config",
            element: <TagConfig />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Cấu hình tag";
                model.value = "system/category-data";
                return model;
              },
            },
          },
          {
            path: "/category-data/address",
            element: <Address />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh mục địa chỉ";
                model.value = "/category-data/address";
                return model;
              },
            },
          },
          {
            path: "/category-data/address-conversion",
            element: <AddressConversion />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh mục chuyển đổi địa chỉ";
                model.value = "/category-data/address-conversion";
                return model;
              },
            },
          },
          {
            path: "/category-data/inventory", //danh mục kho
            element: <DMInventory></DMInventory>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh mục kho";
                model.value = "/category-data/inventory";
                return model;
              },
            },
          },
          {
            path: "/category-data/warehouse-location-list", //danh mục vị trí kho
            element: <WarehouseLocationList></WarehouseLocationList>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh mục vị trí kho";
                model.value = "/category-data/warehouse-location-list";
                return model;
              },
            },
          },
          {
            path: "/category-data/supplies", //danh mục vật tư
            element: <CategoryCombination></CategoryCombination>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh mục vật tư";
                model.value = "/category-data/supplies";
                return model;
              },
            },
          },
          {
            path: "/category-data/accountInformation",
            element: <AccountInformation />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thông tin tài khoản kế toán";
                model.value = "/category-data/accountInformation";
                return model;
              },
            },
          },
          {
            path: "/category-data/reason-for-return",
            element: <ReasonForReturn />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách lý do trả hàng";
                model.value = "/category-data/reason-for-return";
                return model;
              },
            },
          },
          {
            path: "/category-data/voucher",
            element: <ListVoucher />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách voucher";
                model.value = "/category-data/voucher";
                return model;
              },
            },
          },
          {
            path: "/category-data/create-vourcher",
            element: <CreateView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Tạo mới voucher";
                model.value = "/category-data/create-vourcher";
                return model;
              },
            },
          },
          {
            path: "/category-data/edit-vourcher",
            element: <EditView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chỉnh sửa voucher";
                model.value = "/category-data/edit-vourcher";
                return model;
              },
            },
          },
          {
            path: "/category-data/detail-vourcher",
            element: <DetailView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Xem chi tiết voucher";
                model.value = "/category-data/detail-vourcher";
                return model;
              },
            },
          },
          // {
          //   path: "/category-data/related-promotions",
          //   element: <RelatedPromotions />,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       model.text = "Quà khuyến mãi tương đương";
          //       model.value = "/category-data/related-promotions";
          //       return model;
          //     },
          //   },
          // },
          {
            path: "/category-data/tem-product",
            element: <TemProduct />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách tem sản phẩm";
                model.value = "/category-data/tem-product";
                return model;
              },
            },
          },
          {
            path: "/category-data/transport-configuration",
            element: <TabListDeliveryConfig />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Cấu hình giao vận";
                model.value = "/category-data/transport-configuration";
                return model;
              },
            },
          },
          {
            path: "/category-data/technical-configuration",
            element: <TechnicalConfiguration />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Cấu hình kỹ thuật cho giao vận";
                model.value = "/category-data/technical-configuration";
                return model;
              },
            },
          },
          {
            path: "/category-data/serial-status-settings",
            element: <SerialStatus />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thiết lập trạng thái serial";
                model.value = "/category-data/serial-status-settings";
                return model;
              },
            },
          },
          {
            path: "/category-data/reason-request-transfer",
            element: <ReasonRequestTransfer />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thiết lập lý do YCDC";
                model.value = "/category-data/reason-request-transfer";
                return model;
              },
            },
          },
          {
            path: "/category-data/test-level-categories",
            element: <TestLevelCategories />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thiết lập mức độ test của KT";
                model.value = "/category-data/test-level-categories";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/invoice",
        //   element: <SystemView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Danh mục hóa đơn";
            model.value = "/invoice";
            return model;
          },
        },
        children: [
          {
            path: "/invoice/list",
            element: <Invoice />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Hóa đơn";
                model.value = "/list";
                return model;
              },
            },
          },
        ],
      },

      {
        path: "/config-system",
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Thiết lập hệ thống";
            model.value = "/config-system";
            return model;
          },
        },
        children: [
          {
            path: "/config-system/config-price",
            element: <ListPrice></ListPrice>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thiết lập bảng giá bán";
                model.value = "system/config-system";
                return model;
              },
            },
          },
          {
            path: "/config-system/list-details-price",
            element: <ListDetailsPrice></ListDetailsPrice>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thiết lập bảng giá bán";
                model.value = "/config-system/list-details-price";
                return model;
              },
            },
          },
          {
            path: "/config-system/list-details-price-edit/:id",
            element: <ListDetailsPriceEditOld />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chỉnh sửa bảng giá bán";
                model.value = "/config-system/list-details-price-edit/:id";
                return model;
              },
            },
          },
          {
            path: "/config-system/list-details-price-detail/:id",
            element: <ListDetailsPriceDetai />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chi tiết bảng giá bán";
                model.value = "/config-system/list-details-price-edit/:id";
                return model;
              },
            },
          },
          {
            path: "/config-system/configsss-description-policy",
            element: <DetailPromotion></DetailPromotion>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thiết lập mô tả khuyến mãi";
                model.value = "/config-system/configsss-description-policy";
                return model;
              },
            },
          },
          {
            path: "/config-system/config-promotion-policy",
            element: <PromotionPolicy></PromotionPolicy>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thiết lập chính sách khuyến mãi";
                model.value = "/config-system/config-promotion-policy";
                return model;
              },
            },
          },
          {
            path: "/config-system/config-promotion-policy-multiple",
            element: <PromotionPolicyMultiple></PromotionPolicyMultiple>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thiết lập chính sách khuyến mãi đa điều kiện";
                model.value = "/config-system/config-promotion-policy-multiple";
                return model;
              },
            },
          },
          {
            path: "/config-system/profit-revenue-promotion",
            element: <ProfitRevenue isModal={false} />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo doanh thu CTKM dự kiến";
                model.value = "/config-system/profit-revenue-promotion";
                return model;
              },
            },
          },
          {
            path: "/config-system/promotion-report",
            element: <PromotionReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo CTKM";
                model.value = "/config-system/promotion-report";
                return model;
              },
            },
          },
          {
            path: "/config-system/create-promotion-policy",
            element: <CreatePromotionPolicy></CreatePromotionPolicy>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chính sách khuyến mãi";
                model.value = "/config-system/config-promotion-policy";
                return model;
              },
            },
          },
          {
            path: "/config-system/create-promotion-policy-multiple",
            element: <CreatePromotionPolicyMultiple />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chính sách khuyến mãi đa điều kiện";
                model.value = "/config-system/config-promotion-policy-multiple";
                return model;
              },
            },
          },
          {
            path: "/config-system/detail-promotion",
            element: <ViewDetailPromotion></ViewDetailPromotion>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chính sách khuyến mãi";
                model.value = "/config-system/config-promotion-policy";
                return model;
              },
            },
          },
          {
            path: "/config-system/detail-promotion-multiple/:id",
            element: <DetailPromotionPolicyMultiple />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chính sách khuyến mãi đa điều kiện";
                model.value = "/config-system/detail-promotion-multiple";
                return model;
              },
            },
          },

          {
            path: "/config-system/edit-promotion/:id",
            element: <EditPromotionPolicyV2></EditPromotionPolicyV2>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                return model;
              },
            },
          },

          {
            path: "/config-system/edit-promotion-multiple/:id",
            element: <EditPromotionPolicyMultiple />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chính sách khuyến mãi đa điều kiện";
                model.value = "/config-system/edit-promotion-multiple/:id";
                return model;
              },
            },
          },

          {
            path: "/config-system/general-settings",
            element: <ListPrice></ListPrice>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                return model;
              },
            },
          },

          {
            path: "/config-system/config-bom",
            element: <MfgBomView></MfgBomView>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thiết lập định mức nguyên vật liệu";
                model.value = "/config-system/config-bom";
                return model;
              },
            },
          },
          {
            path: "/config-system/set-up-discounts",
            element: <SetUpDiscounts />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thiết lập các mức giảm giá";
                model.value = "/config-system/set-up-discounts";
                return model;
              },
            },
          },
          {
            path: "/config-system/create-config-bom",
            element: <CreateMfgBom></CreateMfgBom>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thiết lập định mức nguyên vật liệu";
                model.value = "/config-system/create-config-bom";
                return model;
              },
            },
          },
          {
            path: "/config-system/set-up-discounts",
            element: <SetUpDiscounts />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thiết lập các mức giảm giá";
                model.value = "/config-system/set-up-discounts";
                return model;
              },
            },
          },
          {
            path: "/config-system/edit-config-bom",
            element: <EditMfgBom></EditMfgBom>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thiết lập định mức nguyên vật liệu";
                model.value = "/config-system/edit-config-bom";
                return model;
              },
            },
          },

          {
            path: "/config-system/detail-config-bom",
            element: <DetailMfgBom></DetailMfgBom>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thiết lập định mức nguyên vật liệu";
                model.value = "/config-system/detail-config-bom";
                return model;
              },
            },
          },
          {
            path: "/config-system/sync-checking-exist",
            element: <TabSyncCheckingExit></TabSyncCheckingExit>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đối chiếu dữ liệu đồng bộ";
                model.value = "/config-system/sync-checking-exist";
                return model;
              },
            },
          },
          {
            path: "/config-system/checking-exist",
            element: <CheckDataView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đối chiếu dữ liệu trên Asia và Pos";
                model.value = "/config-system/checking-exist";
                return model;
              },
            },
          },
          {
            path: "/config-system/compare-promotion-pos-web",
            element: <ComparePromotionPOSAndWEB />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đối chiếu CTKM trên POS và WEB";
                model.value = "/config-system/compare-promotion-pos-web";
                return model;
              },
            },
          },
          {
            path: "/config-system/duplicate-report",
            element: <TabDuplicateReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Kiểm tra dữ liệu hệ thống";
                model.value = "/config-system/duplicate-report";
                return model;
              },
            },
          },
          {
            path: "/config-system/list-promotion-on-product",
            element: <ListPromotionByItem />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách khuyến mãi theo sản phẩm";
                model.value = "/config-system/list-promotion-on-product";
                return model;
              },
            },
          },
          {
            path: "/config-system/schedule-price-list-upload",
            element: <SchedulePriceListUpload />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lập lịch cập nhật bảng giá";
                model.value = "/config-system/schedule-price-list-upload";
                return model;
              },
            },
          },
          {
            path: "/config-system/price-list-update-history",
            element: <PriceListUpdateHistory />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lịch sử cập nhật bảng giá (có giá nhập)";
                model.value = "/config-system/price-list-update-history";
                return model;
              },
            },
          },
          {
            path: "/config-system/price-list-update-history-no-import-price",
            element: <PriceListUpdateHistoryNoImportPrice />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lịch sử cập nhật bảng giá";
                model.value =
                  "/config-system/price-list-update-history-no-import-price";
                return model;
              },
            },
          },
          {
            path: "/config-system/report-price-list",
            element: <ReportPriceList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo bảng giá";
                model.value = "/config-system/report-price-list";
                return model;
              },
            },
          },
          {
            path: "/config-system/rock-bottom-price-list",
            element: <RockBottomPriceList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Bảng giá sập sàn";
                model.value = "/config-system/rock-bottom-price-list";
                return model;
              },
            },
          },
          {
            path: "/config-system/item-fluctuation",
            element: <ItemFluctuation isHome={false} />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách hàng hóa có biến động giá";
                model.value = "/config-system/item-fluctuation";
                return model;
              },
            },
          },
          {
            path: "/config-system/check-summary-price",
            element: <CheckSummaryPrice />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Kiểm tra tổng giá";
                model.value = "/config-system/check-summary-price";
                return model;
              },
            },
          },
          {
            path: "/config-system/zns-configuration",
            element: <ZNSConfiguration />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Cấu hình ZNS";
                model.value = "/config-system/zns-configuration";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/warehouse-config",
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Cấu hình kho hàng";
            model.value = "/warehouse-config";
            return model;
          },
        },
        children: [
          {
            path: "/warehouse-config/inoutwarehouse-management",
            element: <InOutWarehouseOutWard />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Theo dõi nhập/xuất";
                model.value = "/warehouse-config/inoutwarehouse-management";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/serial-stocktake",
            element: <SerialStocktake />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Kiểm kê serial POS";
                model.value = "/warehouse-config/serial-stocktake";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/serial-stocktake-difference-report",
            element: <SerialStocktakeDifferenceReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo kiểm kê theo serial";
                model.value =
                  "/warehouse-config/serial-stocktake-difference-report";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/serial-stocktake-summary-report",
            element: <SerialStocktakeSummaryReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo kiểm kê theo mã vật tư";
                model.value =
                  "/warehouse-config/serial-stocktake-summary-report";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/barcode-status",
            element: <BarcodeStatus />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Trạng thái mã vạch";
                model.value = "/warehouse-config/barcode-status";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/import-purchases",
            element: <ImportPurchases />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đơn mua hàng";
                model.value = "/warehouse-config/warehouse-config";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/purchase-order",
            element: <ImportPurchasesView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách đơn mua hàng";
                model.value = "/warehouse-config/warehouse-config";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/purchase-order-detail",
            element: <ImportPurchasesDetail />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách chi tiết đơn mua hàng";
                model.value = "/warehouse-config/warehouse-config";
                return model;
              },
            },
          },
          // {
          //   path: "/warehouse-config/supplier-slip",
          //   element: <SupplierSlip />,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       model.text = "Danh sách phiếu nhập từ nhà cung cấp";
          //       model.value = "/warehouse-config/warehouse-config";
          //       return model;
          //     },
          //   },
          // },
          {
            path: "/warehouse-config/export-supplier-slip",
            element: <SupplierSlipExport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu cần xuất từ Asia";
                model.value = "/warehouse-config/warehouse-config";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/import-supplier-slip",
            element: <SupplierSlipImport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu cần nhập từ Asia";
                model.value = "/warehouse-config/warehouse-config";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/list-serial",
            element: <ListSerial />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách kho serial";
                model.value = "/warehouse-config/warehouse-config";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/warehouse-management",
            element: <WarehouseManagement />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Kiểm kê kho";
                model.value = "/warehouse-config/warehouse-config";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/inventory-cycle-count",
            element: <InventoryCycleCount />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                return model;
              },
            },
          },

          {
            path: "/warehouse-config/request-transfer",
            element: <RequestTransfer />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lập yêu cầu điều chuyển kho";
                model.value = "/warehouse-config/request-transfer";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/request-transfer-internal",
            element: <RequestTransferInternal />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Yêu cầu điều chuyển (nội bộ)";
                model.value = "/warehouse-config/request-transfer-internal";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/create-request-transfer",
            element: <CreateRequestTransfer />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Yêu cầu điều chuyển kho";
                model.value = "/warehouse-config/create-request-transfer";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/edit-request-transfer",
            element: <EditRequestTransfer />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Yêu cầu điều chuyển kho";
                model.value = "/warehouse-config/edit-request-transfer";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/detail-request-transfer",
            element: <DetailRequestTransfer />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Yêu cầu điều chuyển kho";
                model.value = "/warehouse-config/detail-request-transfer";
                return model;
              },
            },
          },

          {
            path: "/warehouse-config/request-inventory-transaction",
            element: <RequestInventoryTransaction />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu cần xuất kho";
                model.value = "/warehouse-config/request-inventory-transaction";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/request-inward-transaction",
            element: <InwardRequest />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu cần nhập kho";
                model.value = "/warehouse-config/request-inward-transaction";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/warehouse-transaction",
            element: <WarehouseTransaction />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Quản lý sổ kho";
                model.value = "/warehouse-config/warehouse-transaction";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/warehouse-out-ward",
            element: <WarehouseOutWard />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu xuất kho";
                model.value = "/warehouse-config/warehouse-out-ward";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/create-warehouse-out-ward",
            element: <OutwardActionDispatcher />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu xuất kho";
                model.value = "/warehouse-config/create-warehouse-out-ward";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/supplier-request-form",
            element: <WarehouseInWardPlus />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu nhập hàng nhà cung cấp";
                model.value = "/warehouse-config/supplier-request-form";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/edit-warehouse-out-ward",
            element: <OutwardActionDispatcher />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu xuất kho";
                model.value = "/warehouse-config/edit-warehouse-out-ward";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/detail-warehouse-out-ward",
            element: <OutwardActionDispatcher />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu xuất kho";
                model.value = "/warehouse-config/detail-warehouse-out-ward";
                return model;
              },
            },
          },

          {
            path: "/warehouse-config/warehouse-in-ward",
            element: <WarehouseInWard />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu nhập kho";
                model.value = "/warehouse-config/warehouse-in-ward";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/create-warehouse-in-ward",
            element: <InwardActionDispatcher />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu nhập kho";
                model.value = "/warehouse-config/create-warehouse-in-ward";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/create-finished-product-receipt",
            element: <WarehouseInWardPlus />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu nhập kho";
                model.value =
                  "/warehouse-config/create-finished-product-receipt";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/edit-warehouse-in-ward",
            element: <InwardActionDispatcher />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu nhập kho";
                model.value = "/warehouse-config/edit-warehouse-in-ward-plus";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/detail-warehouse-in-ward",
            element: <InwardActionDispatcher />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu nhập kho";
                model.value = "/warehouse-config/detail-warehouse-in-ward";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/create-warehouse-purchase-in-ward",
            element: <CreateWarehousePurchaseInWard />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu nhập kho mua hàng";
                model.value =
                  "/warehouse-config/create-warehouse-purchase-in-ward";
                return model;
              },
            },
          },
          //MfgWip
          {
            path: "/warehouse-config/wip",
            element: <MfgWip />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lệnh sản xuất";
                model.value = "/warehouse-config/wip";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/wip-report",
            element: <MfgWipReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo lắp ráp máy";
                model.value = "/warehouse-config/wip-report";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/machine-installation-inventory-report",
            element: <MachineInstallationInventoryReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tồn kho lắp máy";
                model.value =
                  "/warehouse-config/machine-installation-inventory-report";
                return model;
              },
            },
          },

          // {
          //   path: "/warehouse-config/detail-wip",
          //   element: <DetailWipView />,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       model.text = "Chi tiết lệnh sản xuất";
          //       model.value = "/warehouse-config/detail-wip";
          //       return model;
          //     },
          //   },
          // },
          {
            path: "/warehouse-config/export-adjustment",
            element: <ExportAdjustment />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Xuất kho hủy";
                model.value = "/warehouse-config/export-adjustment";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/inventoryReport",
            element: <InventoryReportList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tồn kho số lượng";
                model.value = "/warehouse-config/inventoryReport";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/inventoryReportHb",
            element: <InventoryReportHbList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tồn kho số lượng hàng bán";
                model.value = "/warehouse-config/inventoryReportHb";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/report-request-transfer",
            element: <ReportRequestTransfer />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo yêu cầu điều chuyển";
                model.value = "/warehouse-config/report-request-transfer";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/general-inventory",
            element: <ReportGeneralInventory />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tồn kho tổng quát";
                model.value = "/warehouse-config/general-inventory";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/inventoryReportList",
            element: <InventoryReportLocation />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tồn kho theo vị trí";
                model.value = "/warehouse-config/inventoryReportList";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/report-on-comparing-serial-inventory-and-quantity-inventory",
            element: <ReportOnComparingSerialInventoryAndQuantityInventory />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text =
                  "Báo cáo so sánh tồn kho serial và tồn kho số lượng";
                model.value =
                  "/warehouse-config/report-on-comparing-serial-inventory-and-quantity-inventory";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/report-serial-status",
            element: <ReportSerialStatus />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tình trạng serial";
                model.value = "/warehouse-config/report-serial-status";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/thong-tin-yeu-cau-nhap-mua",
            element: <ThongTinYeuCauNhapMua />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo mã vạch có người đề nghị";
                model.value = "/warehouse-config/thong-tin-yeu-cau-nhap-mua";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/overdue-pending-outbound-report",
            element: <OverduePendingOutboundReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo phiếu cần xuất kho quá hạn";
                model.value =
                  "/warehouse-config/overdue-pending-outbound-report";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/InventoryReportByBarcode",
            element: <InventoryReportByBarcode />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tồn kho theo mã vạch";
                model.value = "/warehouse-config/InventoryReportByBarcode";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/InventoryReportByBarcodeV2",
            element: <InventoryReportByBarcodeV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tồn kho theo mã vạch (đơn giá nhập)";
                model.value = "/warehouse-config/InventoryReportByBarcodeV2";
                return model;
              },
            },
          },
          // {
          //   path: "/warehouse-config/inventory-balance-serial-report",
          //   element: <InventoryBalanceSerialReport />,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       model.text = "Báo cáo nhập-xuất-tồn theo mã vạch";
          //       model.value =
          //         "/warehouse-config/inventory-balance-serial-report";
          //       return model;
          //     },
          //   },
          // },
          {
            path: "/warehouse-config/report-in-out-balance",
            element: <ReportInOutBalance />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo nhập-xuất-tồn, tuổi tồn theo mã vạch";
                model.value = "/warehouse-config/report-in-out-balance";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/warehouse-location-list",
            element: <WarehouseLocationList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh mục vị trí kho";
                model.value = "/warehouse-config/warehouse-location-list";
                return model;
              },
            },
          },
          // {
          //   path: "/warehouse-config/finished-goods-receipt-list",
          //   element: <FinishedGoodReceipt />,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       model.text = "Danh sách phiếu nhập thành phẩm";
          //       model.value = "/warehouse-config/finished-goods-receipt-list";
          //       return model;
          //     },
          //   },
          // },
          {
            path: "/warehouse-config/inventoryTransfer",
            element: <InventoryTransactionsReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Bảng kê phiếu nhập/phiếu xuất";
                model.value = "/warehouse-config/inventoryTransfer";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/barcode-history",
            element: <BarcodeHistory />,
          },
          {
            path: "/warehouse-config/category-combination",
            element: <CategoryCombination />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách sản phẩm";
                model.value = "/warehouse-config/category-combination";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/product-separation",
            element: <ProductSeparation />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Rã bộ";
                model.value = "/warehouse-config/product-separation";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/spare-part-report",
            element: <SparePartReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo phụ tùng thay thế";
                model.value = "/warehouse-config/spare-part-report";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/inventoryReportCompany",
            element: <InventoryReportCompanyV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tồn kho số lượng toàn công ty";
                model.value = "/warehouse-config/inventoryReportCompany";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/order-documents",
            element: <InventoryDocuments />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo liệt kê chứng từ giữ hàng";
                model.value = "/warehouse-config/order-documents";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/change-information",
            element: <ChangeInformation />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo nhập-xuất-tồn";
                model.value = "/warehouse-config/change-information";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/inventorySerial",
            element: <InventoryBarcode />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo danh sách mã vạch";
                model.value = "warehouse-config/inventorySerial";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/check-req-tranfer-request",
            element: <ReportVCheckTranferRequestQueryView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo điều chuyển";
                model.value = "warehouse-config/check-req-tranfer-request";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/report-inventory-by-serial",
            element: <ReportInventoryBySerial />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tồn kho theo mã vạch(Chủng,loại)";
                model.value = "/warehouse-config/report-inventory-by-serial";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/iventory-serial-item-by-branch",
            element: <InventorySerialOnhandByBranch />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tồn kho theo chi nhánh";
                model.value =
                  "/warehouse-config/iventory-serial-item-by-branch";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/weighing-report",
            element: <WeighingReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo cân hàng";
                model.value = "/warehouse-config/weighing-report";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/storage-report",
            element: <StorageReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo lưu kho";
                model.value = "/warehouse-config/storage-report";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/storage-report-order",
            element: <StorageReportOrder />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo lưu kho bán hàng";
                model.value = "/warehouse-config/storage-report-order";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/check-req-tranfer-requestv",
            element: <ReportSerialChild />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Serial con";
                model.value = "warehouse-config/check-req-tranfer-request";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/list-edit",
            element: <AdjustmentSlipTransaction />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Điều chỉnh kho";
                model.value = "warehouse-config/list-edit";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/get-inventory-by-serial",
            element: <InventoryBySerial />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tồn kho theo mã vạch, theo người nhập";
                model.value = "warehouse-config/get-inventory-by-serial";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/get-sum-list-serial",
            element: <SumListSerialV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tổng tồn kho theo chi nhánh";
                model.value = "warehouse-config/get-sum-list-serial";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/get-sum-list-serial-qk",
            element: <SumListSerialQKV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tổng tồn kho theo chi nhánh(quá khứ)";
                model.value = "warehouse-config/get-sum-list-serial-qk";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/get-count-export-import-serial",
            element: <CountExportImportSerial />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text =
                  "Báo cáo số lần xuất bán và nhập lại cho từng serial";
                model.value = "warehouse-config/get-count-export-import-serial";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/get-weight-serial",
            element: <GetWeightSerial />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tỷ trọng hàng tồn kho theo thời gian";
                model.value = "/warehouse-config/get-weight-serial";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/list-edit-price",
            element: <EditPriceProduct />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Cập nhật giá sản phẩm đổi mã";
                model.value = "warehouse-config/list-edit";
                return model;
              },
            },
          },
          {
            path: "/warehouse-config/get-warning-fifo",
            element: <GetWarningFIFO />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo vi phạm FIFO";
                model.value = "/warehouse-config/get-warning-fifo";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/stocktaking",
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Kiểm kê";
            model.value = "/stocktaking";
            return model;
          },
        },
        children: [
          {
            path: "/stocktaking/list-serial",
            element: <ListSerialStocktaking />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách serial";
                model.value = "/stocktaking/list-serial";
                return model;
              },
            },
          },
        ],
      },
      // {
      //   path: "/proposal",
      //   element: <ProposalView />,
      //   handle: {
      //     crumb: () => {
      //       let model: SelectListItem = {
      //         disabled: false,
      //         group: null,
      //         selected: false,
      //         text: "",
      //         value: "",
      //       };
      //       model.text = "Đề xuất";
      //       model.value = "/proposal";
      //       return model;
      //     },
      //   },
      //   children: [
      //     {
      //       path: "/proposal/create-proposal",
      //       element: <CreateProposalView />,
      //       index: true,
      //       handle: {
      //         crumb: () => {
      //           let model: SelectListItem = {
      //             disabled: false,
      //             group: null,
      //             selected: false,
      //             text: "",
      //             value: "",
      //           };
      //           model.text = "Tạo đề xuất";
      //           model.value = "/proposal/create-proposal";
      //           return model;
      //         },
      //       },
      //     },
      //     {
      //       path: "/proposal/edit-proposal",
      //       element: <EditProposalView />,
      //       index: true,
      //       handle: {
      //         crumb: () => {
      //           let model: SelectListItem = {
      //             disabled: false,
      //             group: null,
      //             selected: false,
      //             text: "",
      //             value: "",
      //           };
      //           model.text = "Sửa đề xuất";
      //           model.value = "/proposal/edit-proposal";
      //           return model;
      //         },
      //       },
      //     },
      //     {
      //       path: "/proposal/proposal-detail",
      //       element: <DetailProposalView />,
      //       index: true,
      //       handle: {
      //         crumb: () => {
      //           let model: SelectListItem = {
      //             disabled: false,
      //             group: null,
      //             selected: false,
      //             text: "",
      //             value: "",
      //           };
      //           model.text = "Chi tiết đề xuất";
      //           model.value = "/proposal/proposal-detail";
      //           return model;
      //         },
      //       },
      //     },
      //     {
      //       path: "/proposal/approve-proposal",
      //       element: <ApproveProposalView />,
      //       index: true,
      //       handle: {
      //         crumb: () => {
      //           let model: SelectListItem = {
      //             disabled: false,
      //             group: null,
      //             selected: false,
      //             text: "",
      //             value: "",
      //           };
      //           model.text = "Quản lý đề xuất";
      //           model.value = "/proposal/approve-proposal";
      //           return model;
      //         },
      //       },
      //     },
      //   ],
      // },
      {
        path: "/delivery-config",
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Cấu hình giao vận";
            model.value = "system/config-system";
            return model;
          },
        },
        children: [
          // {
          //   path: "/delivery-config/delivery",
          //   element: <Delivery></Delivery>,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       model.text = "Đơn giao hàng (KT bảo hành)";
          //       model.value = "system/config-system";
          //       return model;
          //     },
          //   },
          // },
          {
            path: "/delivery-config/delivery",
            element: <Delivery2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đơn giao hàng";
                model.value = "system/config-system";
                return model;
              },
            },
          },
          // {
          //   path: "/delivery-config/delivery-v3",
          //   element: <Delivery3 />,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       model.text = "Đơn giao hàng (KT thi công)";
          //       model.value = "system/config-system";
          //       return model;
          //     },
          //   },
          // },
          // {
          //   path: "/delivery-config/delivery-v4",
          //   element: <Delivery4 />,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       model.text = "Đơn giao hàng (Dự án)";
          //       model.value = "system/config-system";
          //       return model;
          //     },
          //   },
          // },
          {
            path: "/delivery-config/delivery-assignment",
            element: <DeliveryAssignment></DeliveryAssignment>,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phân đơn hàng giao vận";
                model.value = "system/config-system";
                return model;
              },
            },
          },
          // {
          //   path: "/delivery-config/delivery-create",
          //   element: <CreateDataViewDelivery />,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       return model;
          //     },
          //   },
          // },
          // {
          //   path: "/delivery-config/delivery-dispatch",
          //   element: <DeliveryDispatch></DeliveryDispatch>,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       model.text = "Thực hiện vận đơn (KT bảo hành)";
          //       model.value = "system/config-system";
          //       return model;
          //     },
          //   },
          // },
          {
            path: "/delivery-config/delivery-dispatch",
            element: <DeliveryDispatchDV />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thực hiện vận đơn";
                model.value = "system/config-system";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/ghtk-ahamove-delivery-report",
            element: <GHTKAndAhamoveDelivery />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo điều chuyển đơn vị giao hàng";
                model.value = "/delivery-config/ghtk-ahamove-delivery-report";
                return model;
              },
            },
          },
          // {
          //   path: "/delivery-config/delivery-dispatch-tc",
          //   element: <DeliveryDispatchTC />,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       model.text = "Thực hiện vận đơn (KT thi công)";
          //       model.value = "system/config-system";
          //       return model;
          //     },
          //   },
          // },
          // {
          //   path: "/delivery-config/delivery-dispatch-da",
          //   element: <DeliveryDispatchDA />,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       model.text = "Thực hiện vận đơn (Dự án)";
          //       model.value = "system/config-system";
          //       return model;
          //     },
          //   },
          // },
          {
            path: "/delivery-config/delivery-pay",
            element: <DeliveryPay />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tính lương giao vận";
                model.value = "/delivery-config/delivery-pay";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/Delivery-performance",
            element: <DeliveryPerformanceReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tính lương giao vận";
                model.value = "/delivery-config/Delivery-performance";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/Delivery-performance-kttc",
            element: <DeliveryPayrollKttc />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tính lương giao vận thi công";
                model.value = "/delivery-config/Delivery-performance-kttc";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/project-logistics-total-score-report",
            element: <DeliveryProjectLogisticsReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tổng điểm dự án";
                model.value =
                  "/delivery-config/project-logistics-total-score-report";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/construction-technical-score-summary-report",
            element: <ConstructionTechnicalScoreSummaryReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tổng điểm kỹ thuật thi công";
                model.value =
                  "/delivery-config/construction-technical-score-summary-report";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/Delivery-project",
            element: <DeliveryProjectReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tính lương dự án";
                model.value = "/delivery-config/Delivery-project";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/delivery-pay-kt",
            element: <DeliveryPayKT />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tính lương kỹ thuật giao vận";
                model.value = "/delivery-config/delivery-pay";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/Delivery-all-monney",
            element: <DeliveryMoneyReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tổng tiền đơn hàng";
                model.value = "/delivery-config/Delivery-all-monney";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/Delivery-monney",
            element: <DeliveryMoney />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tiền đơn hàng";
                model.value = "/delivery-config/Delivery-monney";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/DeliveryInOneDay",
            element: <DeliveryInOneDay />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Bảng kê đơn hàng giao hơn 1 vận đơn";
                model.value = "/delivery-config/DeliveryInOneDay";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/ReportOnOrders",
            element: <ReportOnOrders />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text =
                  "Báo cáo các đơn hàng trùng mã KH trong cùng một ngày";
                model.value = "/delivery-config/ReportOnOrders";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/GHTK",
            element: <ListTabGHTK />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo các đơn hàng giao vận GHTK";
                model.value = "/delivery-config/GHTK";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/Ahamove",
            element: <Ahamove />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo các đơn hàng giao vận Ahamove";
                model.value = "/delivery-config/Ahamove";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/COD",
            element: <ListTabCOD />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo các đơn hàng giao vận COD";
                model.value = "/delivery-config/COD";
                return model;
              },
            },
          },
          {
            path: "/delivery-config/not-sync",
            element: <DeliveryNotSync />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo giao vận chưa đồng bộ";
                model.value = "/delivery-config/not-sync";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/system",
        //   element: <SystemView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Hệ thống";
            model.value = "/system";
            return model;
          },
        },
        children: [],
      },

      {
        path: "/sell",
        //   element: <SystemView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Bán hàng";
            model.value = "/sell";
            return model;
          },
        },
        children: [
          {
            path: "/sell/retail-order",
            element: <RetailOrder />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đơn bán lẻ";
                model.value = "system/retail-order";
                return model;
              },
            },
          },
          {
            path: "/sell/retail-order-wholesale",
            element: <WholeSale />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đơn bán buôn";
                model.value = "system/retail-order";
                return model;
              },
            },
          },
          {
            path: "/sell/label-printing",
            element: <LabelPrinting />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "In tem";
                model.value = "/sell/label-printing";
                return model;
              },
            },
          },
          {
            path: "/sell/sales-order-list",
            element: <SalesOrderViewV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách đơn";
                model.value = "system/sales-order";
                return model;
              },
            },
          },
          // {
          //   path: "/sell/detail-sale-out-ward",
          //   element: <SalesOrderListDetail />,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       model.text = "Phiếu xuất kho";
          //       model.value = "/sell/detail-sale-out-ward";
          //       return model;
          //     },
          //   },
          // },
          {
            path: "/sell/sales-order-list-read-only",
            element: <SalesOrderListListReturn />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách đơn (chỉ xem)";
                model.value = "system/sales-order";
                return model;
              },
            },
          },
          {
            path: "/sell/report-order-list-return",
            element: <ReportOrderListListReturn />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo danh sách đơn hàng trả";
                model.value = "/sell/report-order-list-return";
                return model;
              },
            },
          },
          {
            path: "/sell/approve-application-list",
            element: <ApproveApplicationList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách duyệt đơn";
                model.value = "/sell/approve-application-list";
                return model;
              },
            },
          },
          {
            path: "/sell/sales-order-list-web",
            element: <SaleOrderListWebsite />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách đơn website";
                model.value = "/sell/sales-order-list-web";
                return model;
              },
            },
          },
          {
            path: "/sell/compare-sale-order-web",
            element: <CompareSaleOrderWeb />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách đơn website gốc";
                model.value = "/sell/compare-sale-order-web";
                return model;
              },
            },
          },
          {
            path: "/sell/sales-order-list-installment-web",
            element: <SalesOrderListInstallment />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách đơn trả góp website";
                model.value = "/sell/sales-order-list-installment-web";
                return model;
              },
            },
          },
          {
            path: "/sell/purchase-registration-list",
            element: <PurchaseRegistrationList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách đăng kí mua hàng website";
                model.value = "/sell/purchase-registration-list";
                return model;
              },
            },
          },
          {
            path: "/sell/print-product-label",
            element: <PrintProductLabel />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "In tem sản phẩm";
                model.value = "/sell/print-product-label";
                return model;
              },
            },
          },
          {
            path: "/sell/promotion-debt-list",
            element: <PromotionDebtList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách đơn nợ khuyến mãi";
                model.value = "/sell/promotion-debt-list";
                return model;
              },
            },
          },

          {
            path: "/sell/sales-order-list-tmdt",
            // element: <ListOrderTMĐT />,
            element: <ListOrderTMDTV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách đơn TMĐT";
                model.value = "/sell/sales-order-list-tmdt";
                return model;
              },
            },
          },
          {
            path: "/sell/sales-order-list-tmdt-read-only",
            element: <ListOrderTMDTReadOnly />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách đơn TMĐT (Chỉ xem)";
                model.value = "/sell/sales-order-list-tmdt-read-only";
                return model;
              },
            },
          },
          {
            path: "/sell/retail-order-tmdt",
            element: <OrderDetailTMĐT />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đơn TMĐT";
                model.value = "/sell/retail-order-tmdt";
                return model;
              },
            },
          },
          {
            path: "/sell/sales-order-list-return-tmdt",
            element: <ListOrderReturnTMDT />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách đơn hoàn TMDT";
                model.value = "/sell/sales-order-list-return-tmdt";
                return model;
              },
            },
          },
          {
            path: "/sell/sales-order-list-cancel-tmdt",
            element: <ListOrderCancelTMDT />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách hủy TMDT";
                model.value = "/sell/sales-order-list-cancel-tmdt";
                return model;
              },
            },
          },
          {
            path: "/sell/return-order-tmdt-detail",
            element: <OrderDetailReturnTMDT />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chi tiết đơn hoàn TMDT";
                model.value = "/sell/return-order-tmdt-detail";
                return model;
              },
            },
          },
          {
            path: "/sell/sales-order-list-origin-approva",
            element: <SalesOrderViewOpproval />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách chờ duyệt giảm";
                model.value = "/sell/sales-order-list-origin-approva";
                return model;
              },
            },
          },
          {
            path: "/sell/sales-order-list-completed",
            element: <SalesOrderListCompleted />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách đơn đã duyệt giảm";
                model.value = "/sell/sales-order-list-completed";
                return model;
              },
            },
          },
          {
            path: "/sell/return-exchange-approval-list",
            element: <SalesOrderListApprovedReturn />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách duyệt đổi trả";
                model.value = "/sell/return-exchange-approval-list";
                return model;
              },
            },
          },
          {
            path: "/sell/banking-transactions",
            element: <BankTransactions />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Giao dịch ngân hàng";
                model.value = "/sell/banking-transactions";
                return model;
              },
            },
          },
          {
            path: "/sell/approved-discount-order",
            element: <RetailOrder />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Duyệt xin giảm giá";
                model.value = "system/sales-order";
                return model;
              },
            },
          },
          {
            path: "/sell/exchange-order",
            element: <RetailOrder />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đổi sản phẩm";
                model.value = "system/sales-order";
                return model;
              },
            },
          },
          {
            path: "/sell/revise-order",
            element: <RetailOrder />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Sửa đơn hàng bán";
                model.value = "system/sales-order";
                return model;
              },
            },
          },
          {
            path: "/sell/revise-whole-order",
            element: <WholeSale />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Sửa đơn hàng bán buôn";
                model.value = "system/sales-order";
                return model;
              },
            },
          },
          {
            path: "/sell/view-order",
            element: <RetailOrder />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Xem đơn hàng bán";
                model.value = "system/sales-order";
                return model;
              },
            },
          },
          {
            path: "/sell/payment-order",
            element: <RetailOrder />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thanh toán đơn hàng";
                model.value = "system/sales-order";
                return model;
              },
            },
          },
          {
            path: "/sell/return-order",
            element: <ReturnOrder />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Tạo đơn trả hàng";
                model.value = "system/sales-order";
                return model;
              },
            },
          },
          {
            path: "/sell/return-order-v2",
            element: <ReturnOrderV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Tạo đơn trả hàng";
                model.value = "system/sales-order";
                return model;
              },
            },
          },
          {
            path: "/sell/return-order-technical",
            element: <ReturnOrderTechnical />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đơn đổi trả kỹ thuật";
                model.value = "sell/return-order-technical";
                return model;
              },
            },
          },
          {
            path: "/sell/return-order-all",
            element: <ReturnOrderAll />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Tạo đơn trả hàng";
                model.value = "system/sales-order";
                return model;
              },
            },
          },

          {
            path: "/sell/revise-order-return",
            element: <ReturnOrderV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Sửa đơn hàng đổi trả";
                model.value = "system/sales-order";
                return model;
              },
            },
          },

          {
            path: "/sell/view-order-return",
            element: <ReturnOrderV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Xem đơn đổi trả";
                model.value = "system/sales-order";
                return model;
              },
            },
          },

          {
            path: "/sell/payment-order-return",
            element: <ReturnOrderV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thanh đoán đơn đổi trả";
                model.value = "system/sales-order";
                return model;
              },
            },
          },

          {
            path: "/sell/approved-discount-order-wholesale",
            element: <WholeSale />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Duyệt giá bán buôn";
                model.value = "system/sales-order";
                return model;
              },
            },
          },

          {
            path: "/sell/view-return-order",
            element: <ReturnOrder />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Xem đơn trả hàng";
                model.value = "system/sales-order";
                return model;
              },
            },
          },

          {
            path: "/sell/payment-return-order",
            element: <ReturnOrder />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thanh toán đơn trả hàng";
                model.value = "system/sales-order";
                return model;
              },
            },
          },

          {
            path: "/sell/customer",
            element: <DmCustomer />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Khách hàng";
                model.value = "system/sales-order";
                return model;
              },
            },
          },
          {
            path: "/sell/screen-payment",
            element: <PaymentForm />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thông tin thanh toán";
                model.value = "/sell/screen-payment";
                return model;
              },
            },
          },
          {
            path: "/sell/writeVAT",
            element: <WriteVATV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Viết hóa đơn VAT";
                model.value = "/sell/writeVAT";
                return model;
              },
            },
          },
          {
            path: "/sell/vat-manager",
            element: <VATManagerV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Quản lý hóa đơn VAT";
                model.value = "/sell/vat-manager";
                return model;
              },
            },
          },
          {
            path: "/sell/edit-order-list",
            element: <AdjustmentSlipOrder />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Điều chỉnh đơn hàng";
                model.value = "/sell/edit-order-list";
                return model;
              },
            },
          },
          {
            path: "/sell/sales-order-list-tmdt",
            element: <ListOrderTMDTV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách đơn TMĐT";
                model.value = "/sell/sales-order-list-tmdt";
                return model;
              },
            },
          },
          {
            path: "/sell/retail-order-tmdt",
            element: <OrderDetailTMĐT />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đơn TMĐT";
                model.value = "/sell/retail-order-tmdt";
                return model;
              },
            },
          },
          {
            path: "/sell/sales-order-list-return-tmdt",
            element: <ListOrderReturnTMDT />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách đơn hoàn TMDT";
                model.value = "/sell/sales-order-list-return-tmdt";
                return model;
              },
            },
          },
          {
            path: "/sell/sales-order-list-cancel-tmdt",
            element: <ListOrderCancelTMDT />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách hủy TMDT";
                model.value = "/sell/sales-order-list-cancel-tmdt";
                return model;
              },
            },
          },
          {
            path: "/sell/return-order-tmdt-detail",
            element: <OrderDetailReturnTMDT />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chi tiết đơn hoàn TMDT";
                model.value = "/sell/return-order-tmdt-detail";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/Statement",
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Bảng kê";
            model.value = "/Statement";
            return model;
          },
        },
        children: [
          {
            path: "/Statement/vall-transaction",
            element: <ReportTransaction />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Bảng kê chứng từ";
                model.value = "/Statement/vall-transaction";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/report",
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Báo cáo đơn hàng";
            model.value = "/report";
            return model;
          },
        },
        children: [
          {
            path: "/report/sales-revenue-report-v2",
            element: <SalesRevenueReportV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo doanh số tính lương hàng tháng 2.0";
                model.value = "/report/sales-revenue-report-v2";
                return model;
              },
            },
          },
          {
            path: "/report/sales-revenue-report",
            element: <SalesRevenueReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo doanh số tính lương hàng tháng";
                model.value = "/report/sales-revenue-report";
                return model;
              },
            },
          },
          {
            path: "/report/sales-list-order",
            element: <ReportSaleOrder />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo doanh số bán hàng";
                model.value = "/report/sales-list-order";
                return model;
              },
            },
          },
          {
            path: "/report/customer-order-report",
            element: <CustomerOrderReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo số lượng đơn và doanh số theo khách hàng";
                model.value = "/report/customer-order-report";
                return model;
              },
            },
          },
          {
            path: "/report/sales-list-order-mobile-app",
            element: <ReportSaleOrderMobileApp />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo doanh số bán hàng Mobile app";
                model.value = "/report/sales-list-order-mobile-app";
                return model;
              },
            },
          },
          {
            path: "/report/sales-list-by-day",
            element: <GeneralSalesStatement />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo bán hàng theo ngày";
                model.value = "/report/sales-list-by-day";
                return model;
              },
            },
          },
          {
            path: "/report/sales-list-item",
            element: <ReportProductDefects />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo lãi lỗ theo sản phẩm";
                model.value = "/report/sales-list-item";
                return model;
              },
            },
          },
          {
            path: "/report/sales-list-item-branch",
            element: <ProductPLReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo lãi lỗ theo sản phẩm và chi nhánh";
                model.value = "/report/sales-list-item-branch";
                return model;
              },
            },
          },
          {
            path: "/report/sales-list-phone",
            element: <ReportPhone />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo lãi lỗ theo số điện thoại";
                model.value = "/report/sales-list-phone";
                return model;
              },
            },
          },
          {
            path: "/report/sales-list-not-price",
            element: <ReportPrice />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo sản phẩm không có trong báo giá";
                model.value = "/report/sales-list-not-price";
                return model;
              },
            },
          },
          {
            path: "/report/sales-list-customer",
            element: <ReportCustomer />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo theo thông tin khách hàng mua";
                model.value = "/report/sales-list-customer";
                return model;
              },
            },
          },
          {
            path: "/report/sales-list-department",
            element: <ReportDepartment />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo bán hàng theo bộ phận";
                model.value = "/report/sales-list-department";
                return model;
              },
            },
          },
          {
            path: "/report/sales-list-branch",
            element: <ReportBrach />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo bán hàng theo chi nhánh";
                model.value = "/report/sales-list-branch";
                return model;
              },
            },
          },
          {
            path: "/report/sales-period",
            element: <ReportByPeriod />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo bán hàng theo phân kỳ";
                model.value = "/report/sales-list-branch";
                return model;
              },
            },
          },
          {
            path: "/report/sales-profit-loss-invoice",
            element: <ReportProfitLossByInvoice />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo lãi lỗ theo hoá đơn";
                model.value = "/report/sales-profit-loss-invoice";
                return model;
              },
            },
          },
          {
            path: "/report/order-information",
            element: <SellOrderIinformation />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thông tin đơn hàng";
                model.value = "/report/order-information";
                return model;
              },
            },
          },
          {
            path: "/report/detail-order-information",
            element: <DetailSellOrderInformation />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chi tiết thông tin đơn hàng";
                model.value = "/report/detail-order-information";
                return model;
              },
            },
          },
          {
            path: "/report/sales-list-barcode",
            element: <SalesBarcodeV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo bán hàng theo mã vạch";
                model.value = "/report/sales-list-barcode";
                return model;
              },
            },
          },
          {
            path: "/report/sales-report-by-invoice-with-batch-codes",
            element: <SalesReportByInvoiceWithBatchCodes />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo bán hàng theo hóa đơn có mã dàn";
                model.value =
                  "/report/sales-report-by-invoice-with-batch-codes";
                return model;
              },
            },
          },
          {
            path: "/report/sales-report-by-product",
            element: <SalesReportByProduct />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo doanh số theo sản phẩm";
                model.value = "/report/sales-report-by-product";
                return model;
              },
            },
          },
          {
            path: "/report/sales-report-by-cat-segment-5e",
            element: <SalesReportByCatSegment5e />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo doanh số theo nhóm hàng";
                model.value = "/report/sales-report-by-cat-segment-5e";
                return model;
              },
            },
          },
          {
            path: "/report/sales-report-by-province-or-ward",
            element: <SalesReportByProvinceOrWard />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo doanh số theo tỉnh/thành phố phường/xã";
                model.value = "/report/sales-report-by-province-or-ward";
                return model;
              },
            },
          },
          {
            path: "/report/sales-report-no-address-customer",
            element: <SaleOrderListNoAddressCus />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo đơn hàng của KH không cung cấp địa chỉ";
                model.value = "/report/sales-report-no-address-customer";
                return model;
              },
            },
          },
          {
            path: "/report/sales-report-inventory-value",
            element: <SalesInventoryValue />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo giá trị tồn doanh thu";
                model.value = "/report/sales-report-inventory-value";
                return model;
              },
            },
          },
          {
            path: "/report/inventory-age-report",
            element: <InventoryAge />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tuổi tồn";
                model.value = "/report/inventory-age-report";
                return model;
              },
            },
          },
          {
            path: "/report/inventory-age-report-branch",
            element: <InventoryAgeBranch />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tuổi tồn theo chi nhánh";
                model.value = "/report/inventory-age-report-branch";
                return model;
              },
            },
          },
          {
            path: "/report/discount-approval-report",
            element: <BaoCaoGiamGia />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo duyệt giảm giá";
                model.value = "/report/discount-approval-report";
                return model;
              },
            },
          },
          {
            path: "/report/inventory-age-report-item",
            element: <InventoryAgeItem />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tuổi tồn theo hàng hóa";
                model.value = "/report/inventory-age-report-item";
                return model;
              },
            },
          },
          {
            path: "/report/inventory-age-report-item-group",
            element: <InventoryAgeItemGroup />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tuổi tồn theo nhóm hàng";
                model.value = "/report/inventory-age-report-item-group";
                return model;
              },
            },
          },
          {
            path: "/report/manual-promotion-program-report",
            element: <ManualPromotionProgramReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo CTKM tự nhập";
                model.value = "/report/manual-promotion-program-report";
                return model;
              },
            },
          },
          {
            path: "/report/sales-by-branch",
            element: <SalesByBranch />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo bán hàng theo chi nhánh/bộ phận";
                model.value = "/report/sales-by-branch";
                return model;
              },
            },
          },
          {
            path: "/report/sales-by-staff",
            element: <SalesByStaff />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo bán hàng theo nhân viên";
                model.value = "/report/sales-by-staff";
                return model;
              },
            },
          },
          {
            path: "/report/purchase-order-report-excluding-price-information",
            element: <PurchaseOrderReportExcludingPriceInformation />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đơn mua hàng không có thông tin tiền";
                model.value =
                  "/report/purchase-order-report-excluding-price-information";
                return model;
              },
            },
          },
          {
            path: "/report/get-product-by-serial",
            element: <GetProductBySerial />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo sản phẩm có serial và no serial";
                model.value = "/report/get-product-by-serial";
                return model;
              },
            },
          },
          {
            path: "/report/get-time-THEK-PHG",
            element: <GetTHEKPHG />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo thời hạn phiếu THEK-phiếu PHG";
                model.value = "/report/get-time-THEK-PHG";
                return model;
              },
            },
          },
          {
            path: "/report/get-count-brand-serial",
            element: <GetCountBrandSerial />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text =
                  "Báo cáo đếm số lần điều chuyển chi nhánh cho từng serial";
                model.value = "/report/get-count-brand-serial";
                return model;
              },
            },
          },
          {
            path: "/report/voucher-usage-history",
            element: <VoucherUsageHistory />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lịch sử sử dụng voucher";
                model.value = "/report/voucher-usage-history";
                return model;
              },
            },
          },
          {
            path: "/report/report-use-voucher",
            element: <ReportUseVoucher />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo voucher sử dụng theo chi nhánh";
                model.value = "/report/report-use-voucher";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/bill",
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Phiếu thu chi";
            model.value = "/bill";
            return model;
          },
        },
        children: [
          {
            path: "/bill/list-receipts",
            element: <ListReceipts />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách phiếu";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/handover-slip-list",
            element: <HandoverSlipList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách phiếu bàn giao";
                model.value = "/bill/handover-slip-list";
                return model;
              },
            },
          },
          {
            path: "/bill/handover-slip-list",
            element: <HandoverSlipList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách phiếu bàn giao";
                model.value = "/bill/handover-slip-list";
                return model;
              },
            },
          },
          {
            path: "/bill/handover-slip-detail",
            element: <HandoverSlipDetail />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chi tiết phiếu bàn giao";
                model.value = "/bill/handover-slip-detail";
                return model;
              },
            },
          },
          {
            path: "/bill/newspaper-list-available",
            element: <NewspaperListAvailable />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách báo có toàn công ty";
                model.value = "/bill/newspaper-list-available";
                return model;
              },
            },
          },
          {
            path: "/bill/adjustment-slip",
            element: <AdjustmentSlip />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu điều chỉnh";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/add-adjustment-slip",
            element: <AddAdjustmentSlip />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thêm phiếu điều chỉnh";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/list-payment-slip",
            element: <ListPaymentSlip />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách phiếu chi";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/detail-payment-receipt",
            element: <DetailListReceipts />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Xem chi tiết phiếu";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/detail-payment-receipt",
            element: <DetailListReceipts />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Xem chi tiết phiếu";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/payment-receipt",
            element: <PaymentReceipt />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu thu đơn hàng";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/handover-slip",
            element: <HandoverSlipCreate />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu bàn giao";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/order-confirmation",
            element: <OrderConfirmation />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu báo có đơn hàng";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/internal-receipt",
            element: <InternalReceipt />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu thu khác";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/credit-advice",
            element: <CreditAdvice />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lập phiếu báo có khác";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/payment-slip",
            element: <PaymentSlip />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lập phiếu chi";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/payment-slip-branches",
            element: <PaymentSlipBranchs />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lập phiếu chi ";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/debt-note",
            element: <DebtNote />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lập phiếu báo nợ ";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/debt-note-branches",
            element: <DebtNoteBranchs />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lập phiếu báo nợ ";
                model.value = "system/bill";
                return model;
              },
            },
          },
          {
            path: "/bill/exchange-rate",
            element: <ExchangeRate />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Tỉ giá vàng";
                model.value = "system/bill";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/reduced-approval",
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Duyệt giảm";
            model.value = "/reduced-approval";
            return model;
          },
        },
        children: [
          {
            path: "/reduced-approval/discount-approval",
            element: <ReducedApproval />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Duyệt giảm";
                model.value = "/reduced-approval/discount-approval";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/service-repair",
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Dịch vụ sửa chữa";
            model.value = "/service-repair";
            return model;
          },
        },
        children: [
          {
            path: "/service-repair/receive-ticket-list",
            element: <ServiceRepairList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Tiếp nhận dịch vụ";
                model.value = "/service-repair/receive-ticket-list";
                return model;
              },
            },
          },
          {
            path: "/service-repair/detail-receive-ticket",
            element: <ServiceRepairDetailView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chi tiết tiếp nhận dịch vụ";
                model.value = "/service-repair/detail-receive-ticket";
                return model;
              },
            },
          },
          {
            path: "/service-repair/defective-goods-list",
            element: <ServiceRepairDefectiveGoodsList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Bảng kê hàng dịch vụ";
                model.value = "/service-repair/defective-goods-list";
                return model;
              },
            },
          },
          {
            path: "/service-repair/testing-technique",
            element: <ServiceRepairTestingTechniqueList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Kỹ thuật kiểm tra";
                model.value = "/service-repair/testing-technique";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/warranty",
        //   element: <SystemView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Bảo hành";
            model.value = "/warranty";
            return model;
          },
        },
        children: [
          {
            path: "/warranty/barcode-history-v2",
            element: <BarcodeHistoryV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo lịch sử mã vạch V2";
                model.value = "/warranty/barcode-history-v2";
                return model;
              },
            },
          },
          {
            path: "/warranty/warranty-claim-information",
            element: <WarrantyClaimInformation />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách thông tin yêu cầu bảo hành";
                model.value = "/warranty/warranty-claim-information";
                return model;
              },
            },
          },
          {
            path: "/warranty/receive-warranty",
            element: <ReceptionList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lập phiếu tiếp nhận yêu cầu";
                model.value = "/warranty/receive-warranty";
                return model;
              },
            },
          },
          {
            path: "/warranty/detail-receive-warranty",
            element: <ReceiveWarrantyDetailView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chi tiết phiếu tiếp nhận yêu cầu";
                model.value = "/warranty/detail-receive-warranty";
                return model;
              },
            },
          },
          {
            path: "/warranty/customer-group",
            element: <WarrantyCustomerGroupList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Cấu hình nhóm khách hàng";
                model.value = "/warranty/customer-group";
                return model;
              },
            },
          },
          {
            path: "/warranty/warranty-list",
            element: <WarrantyRenewalList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách gia hạn bảo hành";
                model.value = "/warranty/warranty-list";
                return model;
              },
            },
          },
          {
            path: "/warranty/supplier-warranty-export",
            element: <SupplierWarrantyExport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Xuất bảo hành NCC";
                model.value = "/warranty/receive-warranty";
                return model;
              },
            },
          },
          {
            path: "/warranty/request-processing",
            element: <ProcessingAssignment />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Xử lý yêu cầu";
                model.value = "/warranty/receive-warranty";
                return model;
              },
            },
          },
          {
            path: "/warranty/warranty-company",
            element: <WarrantyCompany />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Theo dõi hãng xử lý tại nhà";
                model.value = "/warranty/warranty-company";
                return model;
              },
            },
          },
          {
            path: "/warranty/warranty-company",
            element: <WarrantyCompany />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Theo dõi hãng xử lý tại nhà";
                model.value = "/warranty/warranty-company";
                return model;
              },
            },
          },
          {
            path: "/warranty/perform-home-warranty",
            element: <PerformHomeWarranty />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thực hiện xử lý tại nhà";
                model.value = "/warranty/perform-home-warranty";
                return model;
              },
            },
          },
          {
            path: "/warranty/detail-receive-ticket",
            element: <ReceiveTicketDetailView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chi tiết phiếu tiếp nhận hàng lỗi";
                model.value = "/warranty/detail-receive-ticket";
                return model;
              },
            },
          },
          {
            path: "/warranty/receive-ticket-list",
            element: <ReceiveTicketList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu tiếp nhận hàng lỗi";
                model.value = "/warranty/receive-ticket-list";
                return model;
              },
            },
          },
          {
            path: "/warranty/defective-goods-list",
            element: <DefectiveGoodsList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Bảng kê hàng lỗi (Hàng kho)";
                model.value = "/warranty/defective-goods-list";
                return model;
              },
            },
          },
          {
            path: "/warranty/defective-goods-list-v2",
            element: <DefectiveGoodsListV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Bảng kê hàng lỗi (Hàng khách)";
                model.value = "/warranty/defective-goods-list-v2";
                return model;
              },
            },
          },
          {
            path: "/warranty/return-customers",
            element: <ReturnCustomers />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Xuất trả khách";
                model.value = "/warranty/defective-goods-list";
                return model;
              },
            },
          },
          {
            path: "/warranty/warranty-information",
            element: <WarrantyInformation />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thông tin phân công";
                model.value = "/warranty/warranty-information";
                return model;
              },
            },
          },
          {
            path: "/warranty/warranty-receive-item",
            element: <WarrantyReceiveItem />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu nhập kho hàng lỗi";
                model.value = "/warranty/warranty-receive-item";
                return model;
              },
            },
          },
          {
            path: "/warranty/list-borrowed-goods",
            element: <DMBorrwedGoods />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phiếu xuất nhập hàng mượn";
                model.value = "/warranty/list-borrowed-goods";
                return model;
              },
            },
          },
          {
            path: "/warranty/list-of-borrowed-items",
            element: <ListOfBorrowedItems />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Bảng kê hàng mượn";
                model.value = "/warranty/list-of-borrowed-items";
                return model;
              },
            },
          },
          {
            path: "/warranty/customer-warranty",
            element: <CustMeeting view={"VIEW"} />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thông tin khách hàng hẹn gặp";
                model.value = "/warranty/customer-warranty";
                return model;
              },
            },
          },
          {
            path: "/warranty/create-borrowed-goods",
            element: <CreateExportBorrwedGood />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thêm mới phiếu xuất nhập hàng mượn";
                model.value = "/warranty/create-borrowed-goods";
                return model;
              },
            },
          },
          {
            path: "/warranty/detail-borrowed-goods",
            element: <DetailExportBorredGood />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chi tiết phiếu xuất nhập hàng mượn";
                model.value = "/warranty/detail-borrowed-goods";
                return model;
              },
            },
          },
          {
            path: "/warranty/edit-borrowed-goods",
            element: <EditExportBorred />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chỉnh sửa phiếu xuất nhập hàng mượn";
                model.value = "/warranty/edit-export-borrowed-goods";
                return model;
              },
            },
          },
          {
            path: "/warranty/warranty-conversion-data",
            element: <WarrantyConversionData />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Dữ liệu chuyển đổi bảo hành";
                model.value = "/warranty/warranty-conversion-data";
                return model;
              },
            },
          },
          {
            path: "/warranty/purchase-history",
            element: <PurchaseHistory />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lịch sử mua hàng";
                model.value = "/warranty/purchase-history";
                return model;
              },
            },
          },
          {
            path: "/warranty/product-warranty-history",
            element: <ProductWarrantyHistory />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lịch sử sản phẩm bảo hành";
                model.value = "/warranty/product-warranty-history";
                return model;
              },
            },
          },
          {
            path: "/warranty/report-delivery-performance",
            element: <ReportDeliveryPerformance />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo thực hiện giao hàng";
                model.value = "/warranty/report-delivery-performance";
                return model;
              },
            },
          },
          {
            path: "/warranty/export-or-re-export",
            element: <ExportOrReExport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo serial xuất bán hoặc nhập lại";
                model.value = "/warranty/export-or-re-export";
                return model;
              },
            },
          },
          {
            path: "/warranty/report-export-supplier",
            element: <ReportExportSupplier />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo xuất gửi nhà cung cấp";
                model.value = "/warranty/report-export-supplier";
                return model;
              },
            },
          },
          {
            path: "/warranty/warrantyInformation",
            element: <InformationWarranty />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thông tin bảo hành";
                model.value = "/warranty/warrantyInformation";
                return model;
              },
            },
          },
          {
            path: "/warranty/request-form-report",
            element: <RequestFormReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo thực hiện xử lý yêu cầu";
                model.value = "/warranty/request-form-report";
                return model;
              },
            },
          },
          {
            path: "/warranty/qr-service-receipt-warranty",
            element: <QrCodeWarranty />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "QR tiếp nhận dịch vụ bảo hành";
                model.value = "/warranty/warrantyInformation";
                return model;
              },
            },
          },
          {
            path: "/warranty/inventory-record",
            element: <InventoryRecord />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Biên bản kiểm kê hàng bảo hành";
                model.value = "/warranty/inventory-record";
                return model;
              },
            },
          },
          {
            path: "/warranty/report-defective-goods-rate",
            element: <ReportDefectiveGoodsRate />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tỷ lệ hàng lỗi bảo hành";
                model.value = "/warranty/report-defective-goods-rate";
                return model;
              },
            },
          },
          {
            path: "/warranty/report-inventory-import-warranty-return",
            element: <InventoryImportReturn />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tồn - nhập - trả bảo hành";
                model.value =
                  "/warranty/report-inventory-import-warranty-return";
                return model;
              },
            },
          },
          {
            path: "/warranty/tracking-report-warranty",
            element: <TrackingReportKTBH />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo theo dõi KTBH";
                model.value = "/warranty/tracking-report-warranty";
                return model;
              },
            },
          },
          {
            path: "/warranty/report-for-month",
            element: <ReportForMonth />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tháng KTBH";
                model.value = "/warranty/report-for-month";
                return model;
              },
            },
          },
          {
            path: "/warranty/warranty-reception-processing-report",
            element: <WarrantyReceptionProcessingReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo phân tích tiếp nhận và xử lý bảo hành";
                model.value = "/warranty/warranty-reception-processing-report";
                return model;
              },
            },
          },
          {
            path: "/warranty/inventory-transfer-warranty",
            element: <InventoryTransferWarranty />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Điều chỉnh nhập kho BH NCC";
                model.value = "/warranty/inventory-transfer-warranty";
                return model;
              },
            },
          },
          {
            path: "/warranty/history-sms-bh",
            element: <HistorySMSBH />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lịch sử tin nhắn SMS";
                model.value = "/warranty/history-sms-bh";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/testing",
        //   element: <SystemView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Kiểm tra";
            model.value = "/testing";
            return model;
          },
        },
        children: [
          {
            path: "/testing/testing-technique",
            element: <TestingTechnique />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Kỹ thuật kiểm tra";
                model.value = "/testing/testing-technique";
                return model;
              },
            },
          },
          {
            path: "/testing/create-testing-technique",
            element: <CreateTestingTechnique />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Tạo mới kỹ thuật kiểm tra";
                model.value = "/testing/create-testing-technique";
                return model;
              },
            },
          },
          {
            path: "/testing/detail-testing-technique",
            element: <ModalDetailTestingTechnique />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chi tiết kỹ thuật kiểm tra";
                model.value = "/testing/detail-testing-technique";
                return model;
              },
            },
          },
          {
            path: "/testing/assign-testing-technique",
            element: <ModalAssignTestingTechnique />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chi tiết kỹ thuật kiểm tra";
                model.value = "/testing/assign-testing-technique";
                return model;
              },
            },
          },
          {
            path: "/testing/update-testing-technique",
            element: <ModalUpdateTestingTechnique />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Cập nhật kỹ thuật kiểm tra";
                model.value = "/testing/update-testing-technique";
                return model;
              },
            },
          },
          // {
          //   path: "/testing/reception-testing-technique",
          //   element: <ReceptionTestingTechnique />,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       model.text = "Tiếp nhận kiểm tra";
          //       model.value = "/testing/reception-testing-technique";
          //       return model;
          //     },
          //   },
          // },
          {
            path: "/testing/payroll-report",
            element: <PayrollReport />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tính lương kỹ thuật kiểm tra";
                model.value = "/testing/payroll-report";
                return model;
              },
            },
          },
          {
            path: "/testing/employee-technical-points",
            element: <ReportTotalEmployee />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo tổng điểm nhân viên KTBH";
                model.value = "/testing/employee-technical-points";
                return model;
              },
            },
          },
        ],
      },

      {
        path: "/customer-management",
        //   element: <SystemView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Danh mục dữ liệu";
            model.value = "/customer-management";
            return model;
          },
        },
        children: [
          {
            path: "/customer-management/customer-list",
            element: <CustomerList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách khách hàng";
                model.value = "/customer-management/customer-list";
                return model;
              },
            },
          },
          {
            path: "/customer-management/customer-list-no-debt",
            element: <CustomerList />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "DS khách hàng(không công nợ)";
                model.value = "/customer-management/customer-list-no-debt";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/debtgroup",
        //   element: <SystemView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Danh mục dữ liệu";
            model.value = "/debtgroup";
            return model;
          },
        },
        children: [
          {
            path: "/debtgroup/customer-debtgroup-list",
            element: <DebtGroupListCus type={3} />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách nhóm công nợ khách hàng";
                model.value = "/debtgroup/customer-debtgroup-list";
                return model;
              },
            },
          },
          {
            path: "/debtgroup/supplier-debtgroup-list",
            element: <ListDebtVendor />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách nhà cung cấp";
                model.value = "/debtgroup/supplier-debtgroup-list";
                return model;
              },
            },
          },
          // {
          //   path: "/debtgroup/supplier-debtgroup-list",
          //   element: <DebtGroupList type={2} />,
          //   handle: {
          //     crumb: () => {
          //       let model: SelectListItem = {
          //         disabled: false,
          //         group: null,
          //         selected: false,
          //         text: "",
          //         value: "",
          //       };
          //       model.text = "Danh sách nhóm công nợ nhà cung cấp";
          //       model.value = "/debtgroup/supplier-debtgroup-list";
          //       return model;
          //     },
          //   },
          // },
        ],
      },
      {
        path: "/menuview",
        //   element: <SystemView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Menu";
            model.value = "/menuview";
            return model;
          },
        },
        children: [
          {
            path: "/menuview/list",
            element: <MenuView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách nhóm công nợ";
                model.value = "/menuview/list";
                return model;
              },
            },
          },
        ],
      },

      {
        path: "/authozire",
        //   element: <SystemView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Phân quyền";
            model.value = "/authozire";
            return model;
          },
        },
        children: [
          {
            path: "/authozire/alignment",
            element: <MenuAlignmentView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đồng bộ";
                model.value = "/authozire/alignment";
                return model;
              },
            },
          },
          {
            path: "/authozire/menu-group",
            element: <MenuGroupListView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Nhóm menu";
                model.value = "authozire/menu-group";
                return model;
              },
            },
          },
          {
            path: "/authozire/roles",
            element: <AuthListRoleView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh mục chức năng";
                model.value = "authozire/roles";
                return model;
              },
            },
          },
          {
            path: "/authozire/groups",
            element: <GroupsRoleView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Nhóm người dùng";
                model.value = "authozire/groups";
                return model;
              },
            },
          },
          {
            path: "/authozire/permissions",
            element: <PermissionsPage />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phân quyền (Chức năng & Menu)";
                model.value = "authozire/permissions";
                return model;
              },
            },
          },
          {
            path: "/authozire/groups-brand-inventory",
            element: <GroupUserView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Nhóm kho và vị trí";
                model.value = "authozire/groups-brand-inventory";
                return model;
              },
            },
          },
          {
            path: "/authozire/users",
            element: <UserListView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách người dùng";
                model.value = "authozire/users";
                return model;
              },
            },
          },
          {
            path: "/authozire/decentralize-reduction",
            element: <DecentralizeRedution />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phân quyền xin giảm";
                model.value = "/authozire/decentralize-reduction";
                return model;
              },
            },
          },
          {
            path: "/authozire/return-technical-exchange",
            element: <ReturnTechnicalExchange />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phân quyền duyệt kỹ thuật đổi trả";
                model.value = "/authozire/return-technical-exchange";
                return model;
              },
            },
          },
          {
            path: "/authozire/report-category",
            element: <ReportCategory />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phân quyền báo cáo";
                model.value = "/authozire/report-category";
                return model;
              },
            },
          },
          {
            path: "/authozire/request-manager-transfer",
            element: <RequestManagerTransfer />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách quyền chuyển kho";
                model.value = "/authozire/request-manager-transfer";
                return model;
              },
            },
          },
          {
            path: "/authozire/app",
            element: <AppView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách App";
                model.value = "authozire/app";
                return model;
              },
            },
          },
          {
            path: "/authozire/history-and-approve",
            element: <HistoryAndApprove />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Lịch sử và phê duyệt";
                model.value = "authozire/history-and-approve";
                return model;
              },
            },
          },
          {
            path: "/authozire/logging",
            element: <LoggingView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Nhật ký hệ thống";
                model.value = "authozire/logging";
                return model;
              },
            },
          },
          {
            path: "/authozire/online",
            element: <ListOnlineView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Danh sách online";
                model.value = "authozire/online";
                return model;
              },
            },
          },
          {
            path: "/authozire/logging-req",
            element: <CheckDataLogView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Logging request";
                model.value = "authozire/logging-req";
                return model;
              },
            },
          },
          {
            path: "/authozire/logging-req-v2",
            element: <CheckDataClickHouseLogView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Logging request";
                model.value = "authozire/logging-req-v2";
                return model;
              },
            },
          },
          {
            path: "/authozire/delete-cache",
            element: <DeleteCache />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Xóa cache hệ thống";
                model.value = "/authozire/delete-cache";
                return model;
              },
            },
          },
          {
            path: "/authozire/topic-error",
            element: <TopicErrorView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Topic error";
                model.value = "authozire/logging";
                return model;
              },
            },
          },
          {
            path: "/authozire/user-page",
            element: <UserPageView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Trang cá nhân";
                model.value = "authozire/logging";
                return model;
              },
            },
          },
        ],
      },

      {
        path: "/organization",
        //   element: <SystemView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Dữ liệu chung";
            model.value = "/organization";
            return model;
          },
        },
        children: [
          {
            path: "/organization/department",
            element: <DepartmentView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Phòng ban";
                model.value = "organization/department";
                return model;
              },
            },
          },
          {
            path: "/organization/position",
            element: <RoleView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Chức vụ";
                model.value = "organization/position";
                return model;
              },
            },
          },
          {
            path: "/organization/staff",
            element: <EmployeeView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Nhân viên";
                model.value = "organization/staff";
                return model;
              },
            },
          },
        ],
      },

      {
        path: "/report",
        //   element: <SystemView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Báo cáo";
            model.value = "/report";
            return model;
          },
        },
        children: [
          {
            path: "/report/example",
            element: <GridExample />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Mẫu báo cáo";
                model.value = "report/example";
                return model;
              },
            },
          },
          {
            path: "/report/add-or-update-file",
            element: <AddOrUpdateFileReportView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Thêm template export excel";
                model.value = "report/add-or-update-file";
                return model;
              },
            },
          },
          {
            path: "/report/inventory-serial-onhand",
            element: <ReportInventorySerialOnhandView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Tồn kho theo serial";
                model.value = "report/inventory-serial-onhand";
                return model;
              },
            },
          },
          {
            path: "/report/payment-receipt",
            element: <ReportPaymentReceiptViewV2 />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Báo cáo sổ quỹ";
                model.value = "report/payment-receipt";
                return model;
              },
            },
          },
          {
            path: "/report/sales-list",
            element: <ReportSalesListView />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Bảng kê báng hàng";
                model.value = "report/sales-list";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/warehouse-data",
        //   element: <SystemView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Kho dữ liệu";
            model.value = "/warehouse-data";
            return model;
          },
        },
        children: [
          {
            path: "/warehouse-data/list-warehouse-data",
            element: <ListWarehouseData />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Kho dữ liệu";
                model.value = "/warehouse-data/list-warehouse-data";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/compare",
        //   element: <SystemView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Đối chiếu dữ liệu";
            model.value = "/compare";
            return model;
          },
        },
        children: [
          {
            path: "/compare/compare-data-asia-pos",
            element: <CompareDataAsiaPOS />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đối chiếu dữ liệu POS/ASIA";
                model.value = "/compare/compare-data-asia-pos";
                return model;
              },
            },
          },
          {
            path: "/compare/compare-inventory",
            element: <CompareInventory />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đối chiếu kho POS/ASIA";
                model.value = "/compare/compare-inventory";
                return model;
              },
            },
          },
          {
            path: "/compare/compare-item-pos-asia",
            element: <CompareVT />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đối chiếu vật tư POS/ASIA";
                model.value = "/compare/compare-item-pos-asia";
                return model;
              },
            },
          },
          {
            path: "/compare/compare-item-pos-web",
            element: <CompareItemPOSAndWeb />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đối chiếu sản phẩm POS/Website";
                model.value = "/compare/compare-item-pos-web";
                return model;
              },
            },
          },
          {
            path: "/compare/compare-defective-pos-asia",
            element: <CompareDefectivePOSAndAsia />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Đối chiếu bảng kê POS/ASIA";
                model.value = "/compare/compare-defective-pos-asia";
                return model;
              },
            },
          },
        ],
      },
      {
        path: "/export-data",
        //   element: <SystemView />,
        handle: {
          crumb: () => {
            let model: SelectListItem = {
              disabled: false,
              group: null,
              selected: false,
              text: "",
              value: "",
            };
            model.text = "Xuất dữ liệu";
            model.value = "/export-data";
            return model;
          },
        },
        children: [
          {
            path: "/export-data/export-excel-page",
            element: <ExportExcel />,
            handle: {
              crumb: () => {
                let model: SelectListItem = {
                  disabled: false,
                  group: null,
                  selected: false,
                  text: "",
                  value: "",
                };
                model.text = "Xuất dữ liệu";
                model.value = "/export-data/export-excel-page";
                return model;
              },
            },
          },
        ],
      },
    ],
  },
  {
    path: "auth",
    element: <LayoutAuth />, // Define your Auth layout component here
    children: [
      {
        path: "login",
        element: <LayoutLogin />, // Create a Login page component
      },
      {
        path: "register",
        // element: <AuthenticationRegister />, // Create a Login page component
      },

      // Add more authentication-related routes here
    ],
  },
  {
    path: "send",
    element: <LayoutAnonymus />,
    children: [
      {
        path: "/send/warranty-claim/:id",
        element: <SendWarrantyClaim />, // Create a Login page component
      },
      // Add more authentication-related routes here
    ],
  },
]);

export default router;
